/* eslint-disable camelcase */
/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import {
  isCanada,
  isClient,
  getBrand,
  parseBoolean,
  getABtestFromState,
  getAPIConfig,
  getBrandInCaps,
  isTCP,
  isUsOnly,
  extractDataFromString,
  getUrlParameter,
  checkForKeyInURL,
  getViewportInfo,
  getSessionStorage,
  setSessionStorage,
  isMobileWeb,
} from '@tcp/core/src/utils';
import { safelyParseJSON, safelyParseArray } from '@tcp/core/src/utils/utils';
import { createSelector } from 'reselect';
import COUPON_CONSTANTS from '@tcp/core/src/components/features/CnC/common/organism/CouponAndPromos/Coupon.constants';
import EARNEXTRAPOINTS_CONSTANTS from '@tcp/core/src/components/features/account/common/organism/EarnExtraPointsTile/EarnExtraPointsTile.constants';
import ordersConstants from '@tcp/core/src/components/features/account/Orders/Orders.constants';
import redeemedAndEarnedPerksConstants from '@tcp/core/src/components/features/account/PlacePerks/organism/RedeemedAndEarnedPerks/RedeemedAndEarnedPerks.constants';
import { SESSIONCONFIG_REDUCER_KEY } from '../../constants/reducer.constants';
import { defaultCountries, USA_VALUES } from '../../constants/site.constants';
import { SHOP_THIS_STORE_URL_QUERY_KEY } from '../../constants/shopThisStore.constant';
import { getStoreRef } from '../../utils/store.utils';
import { PRODUCTS_PER_LOAD } from '../../components/features/browse/ProductListing/container/ProductListing.constants';

const COMMA_DELIMITER = ',';
const DEFAULT_PRODUCTS_PER_PAGE = 30;

const getSiteDetails = (state) => {
  return (state[SESSIONCONFIG_REDUCER_KEY] && state[SESSIONCONFIG_REDUCER_KEY].siteDetails) || {};
};

export /**
 *
 * @function getCurrentCountry
 * @param {*} state
 * @description this selector gives current country selected.
 */
const getCurrentCountry = (state) => {
  return state[SESSIONCONFIG_REDUCER_KEY] && state[SESSIONCONFIG_REDUCER_KEY].siteDetails.country;
};

export /**
 *
 * @function getIsInternationalShipping
 * @param {*} state
 * @description this selector gives whether current country is other than US/CA.
 */
const getIsInternationalShipping = (state) => {
  return (
    getCurrentCountry(state) !== defaultCountries[0].id &&
    getCurrentCountry(state) !== defaultCountries[1].id
  );
};

export const getIsRadialInventoryEnabled = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_RADIAL_BOSS_ENABLED
  );
};

export const getIsBrierleyPromoEnabled = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_BRIERLEY_PROMO_ENABLED &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_BRIERLEY_PROMO_ENABLED !== undefined &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_BRIERLEY_PROMO_ENABLED.toLowerCase() ===
        'true'
  );
};
export const getIsBIAEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.IS_BIA_ENABLED)
  );
};

export const getIsHomePageRAR = (state) => {
  return (
    state &&
    state.session.siteDetails &&
    state.session.siteDetails.IS_HOMEPAGE_RAR_ENABLED &&
    parseBoolean(state.session.siteDetails.IS_HOMEPAGE_RAR_ENABLED)
  );
};

export const getIsHomeBirthdayModule = (state) => {
  return (
    state &&
    state.session.siteDetails &&
    state.session.siteDetails.IS_HOMEPAGE_BIRTHDAY_MODULE_ENABLED &&
    parseBoolean(state.session.siteDetails.IS_HOMEPAGE_BIRTHDAY_MODULE_ENABLED)
  );
};

export const getRnRTTL = (state) => {
  return +state?.session?.siteDetails?.RAR_TTL || 1;
};

export const getIsAccountPageRAR = (state) => {
  return (
    state &&
    state.session.siteDetails &&
    state.session.siteDetails.IS_ACCOUNTPAGE_RAR_ENABLED &&
    parseBoolean(state.session.siteDetails.IS_ACCOUNTPAGE_RAR_ENABLED)
  );
};

export const getIsPLPCarouselEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.IS_PLP_CAROUSEL_ENABLED)
  );
};

export const getIsNewSBCImplementationEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.IS_SBC_NEW_IMPLEMENTATION_ENABLED)
  );
};

const getCrossBrandFlags = (state, key) => {
  const brandFlag = parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] && state[SESSIONCONFIG_REDUCER_KEY].siteDetails[key]
  );
  const otherBrandFlag = parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] && state[SESSIONCONFIG_REDUCER_KEY].otherBrandSiteDetails[key]
  );

  return { brandFlag, otherBrandFlag };
};

export const getIsBossAppEnabled = (state) => {
  const { brandFlag } = getCrossBrandFlags(state, 'BOSS_ENABLED_APP');

  return {
    isBossEnabledAppTCP: brandFlag,
    isBossEnabledAppGYM: brandFlag,
  };
};

export const getIsBossEnabled = (state, brand = getBrand()) => {
  const isBOSSEnabled = brand && `isBOSSEnabled_${brand.toUpperCase()}`;
  return (
    state[SESSIONCONFIG_REDUCER_KEY] && state[SESSIONCONFIG_REDUCER_KEY].siteDetails[isBOSSEnabled]
  );
};

export const getIsBopisEnabled = (state, brand = getBrand()) => {
  const isBOPISEnabled = brand && `isBOPISEnabled_${brand.toUpperCase()}`;
  return (
    state[SESSIONCONFIG_REDUCER_KEY] && state[SESSIONCONFIG_REDUCER_KEY].siteDetails[isBOPISEnabled]
  );
};

export const getIsBossClearanceProductEnabled = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.BOSS_ENABLED_CLEARANCE_PRODUCTS
  );
};

export const getIsBopisClearanceProductEnabled = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.BOPIS_ENABLED_CLEARANCE_PRODUCTS
  );
};

export const getIsPDPInventoryCheckEnabled = (state) => {
  if (isClient()) {
    return parseBoolean(
      state &&
        state[SESSIONCONFIG_REDUCER_KEY] &&
        state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_PDP_INVENTORY_CHECK_ENABLED
    );
  }
  return false;
};

export const getIsExtendedInventoryPromoMessagingEnabled = (state) => {
  if (isClient()) {
    return parseBoolean(
      state &&
        state[SESSIONCONFIG_REDUCER_KEY] &&
        state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_EXTENDED_INVENTORY_PROMO_MESSAGING_ENABLED
    );
  }
  return false;
};

export const storeHoursWebEnabled = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_STORE_HOURS_WEB_ENABLED
  );
};

export const getIsCustomerRatingFilterWebEnabled = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_CUSTOMER_RATING_FILTER_WEB_ENABLED
  );
};

export const getIsCustomerRatingFilterAppEnabled = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_CUSTOMER_RATING_FILTER_APP_ENABLED
  );
};

export const storeDetailsRedesignEnabled = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.STORE_DETAILS_REDESIGN_ENABLED
  );
};

export const storeHoursAppEnabled = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_STORE_HOURS_APP_ENABLED
  );
};

export const getCurrentCurrency = (state) => {
  return state[SESSIONCONFIG_REDUCER_KEY] && state[SESSIONCONFIG_REDUCER_KEY].siteDetails.currency;
};

export const getIsPdpServiceEnabled = (state) => {
  return (
    state &&
    state.session.siteDetails &&
    state.session.siteDetails.IS_PDP_SERVICE_ENABLED &&
    parseBoolean(state.session.siteDetails.IS_PDP_SERVICE_ENABLED)
  );
};

export const getCurrentCurrencySymbol = (state) => {
  const country = getCurrentCountry(state);
  if (country === 'US' || country === 'CA') {
    return '$';
  }
  const currency = getCurrentCurrency(state);
  return currency === USA_VALUES.currency ? USA_VALUES.currencySymbol : `${currency} `;
};

export const getRecalcOrderPointsInterval = (state) => {
  return parseInt(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.BRIERLEY_ORD_RECALC_CACHING_INTERVAL,
    10
  );
};

export const getTcpSegmentValue = (state) => {
  return (
    state[SESSIONCONFIG_REDUCER_KEY] && state[SESSIONCONFIG_REDUCER_KEY].siteDetails.tcpSegment
  );
};

export const getIsKeepAliveProduct = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.KEEPALIVE_PRODUCTFLAG
  );
};

export const getIsKeepAliveProductApp = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.KEEPALIVE_PRODUCTFLAG_APP
  );
};

export const getIsForterEnabled = (state) => {
  return (
    !state[SESSIONCONFIG_REDUCER_KEY] ||
    (state[SESSIONCONFIG_REDUCER_KEY].siteDetails.FORTER_ENABLED !== 0 &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.FORTER_ENABLED !== '0')
  );
};

export const getDisplayAvailableOffersAbTest = (state) => {
  return (
    state?.AbTest &&
    getABtestFromState(state.AbTest).displayAvailableOffersCart &&
    !getIsInternationalShipping(state)
  );
};

export const getIsNewCouponPlacementEnable = (state) => {
  return state?.AbTest && getABtestFromState(state.AbTest).isNewCouponPlacementOn;
};

export const getIsDefaultApplePayAbTest = (state) => {
  return state?.AbTest && getABtestFromState(state.AbTest).isDefaultApplePayAbTestEnabled;
};
export const getIsPlccPriceOnPDP = (state) => {
  return state?.AbTest && getABtestFromState(state.AbTest).isPlccPriceOnPDP;
};

export const getDefaultAfterPayAbTest = (state) => {
  return state?.AbTest && parseBoolean(state?.AbTest?.isDefaultAfterPayAbtestEnabled);
};

export const getIsGuestFavEnabled = (state) => {
  return state?.AbTest?.isGuestFavEnabled && parseBoolean(state.AbTest.isGuestFavEnabled);
};

export const getIsGuestFavAppEnabled = (state) => {
  return state?.AbTest && getABtestFromState(state.AbTest).isGuestFavAppEnabled;
};

export const getOverrideDefaultPaymentMethod = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.IS_OVERRIDE_DEFAULT_PAYMENT_ENABLED)
  );
};

export const getAfterPayParam = (state) => {
  return (
    state.session && state.session.siteDetails && state.session.siteDetails.DEFAULT_AFTERPAY_PARAM
  );
};

export const getIsPLCCInstantCheckout = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.IS_PLCC_CHECKOUT_ENABLED)
  );
};

export const getABTestIsNewVendorEnabled = (state) => {
  return state?.AbTest && getABtestFromState(state.AbTest).isNewVendorEnabled;
};

export const getABTestIsMiniBagEnabled = (state) => {
  return state?.AbTest && getABtestFromState(state.AbTest).isMiniBagEnabled;
};

export const getAbTestIsVerticalCTLEnabled = (state) => {
  return getABtestFromState(state.AbTest).isVerticalCTLEnabled;
};

export const getAbTestIsVerticalRecommendationsEnabled = (state) => {
  return getABtestFromState(state.AbTest).isVerticalRecommendationsEnabled;
};

export const getIsOneClickATCEnabled = (state) => {
  return getABtestFromState(state.AbTest).isOneClickATCEnabled;
};

export const getAbTestIsTopRatedBadgeEnabled = (state) => {
  return getABtestFromState(state.AbTest).isTopRatedBadgeEnabled;
};

export const getAbTestIsMostFavoritedBackAbEnabled = (state) => {
  return getABtestFromState(state.AbTest).isMostFavoritedBadgeEnabled;
};

export const getAbTestIsESGBadgePDPBackABEnabled = (state) => {
  return getABtestFromState(state.AbTest).isESGBadgePDPBackABEnabled;
};

export const getAbTestIsAppTopRatedBadgeEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.IS_TOP_RATED_BADGE_ENABLED_APP)
  );
};

export const getAbTestIsAppBestSellerBadgeEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.IS_BEST_SELLER_BADGE_ENABLED_APP)
  );
};

export const getIsTopRatedBadgeEnabledSLP = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_TOP_RATED_BADGE_ENABLED_SLP)
  );
};

export const getIsBestSellerBadgeEnabledSLP = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_BEST_SELLER_BADGE_ENABLED_SLP)
  );
};

export const getTopRatedAttributeToBeChecked = (state) => {
  return (
    (state &&
      state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.TOP_RATED_ATTRIBUTE_TO_BE_CHECKED) ||
    ''
  );
};

export const getMostFavoritedAttributeToBeChecked = (state) => {
  return (
    (state &&
      state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.MOST_FAVORITED_ATTRIBUTE_TO_BE_CHECKED) ||
    ''
  );
};

export const getBestSellerAttributeToBeChecked = (state) => {
  return (
    (state &&
      state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.BEST_SELLER_ATTRIBUTE_TO_BE_CHECKED) ||
    ''
  );
};

export const getAbTestIsBestSellerBackAbTestEnabled = (state) => {
  return getABtestFromState(state.AbTest).isBestSellerBackAbEnabled;
};

export const getIsFBTShowEnabled = (state) => {
  return getABtestFromState(state.AbTest).isFBTShow;
};

export const gethideHelpIconOnPDPScrollEnabled = (state) => {
  return (
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails.ishideHelpIconOnPDPScrollEnabled
  );
};

export const getSpecialHoursNumberOfDaysToConsider = (state) => {
  return (
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails.SPECIAL_HOURS_DAYS_COUNT
  );
};

export const getABTestIsSearchEnhancementRedesignEnabled = (state) => {
  const isSearchEnhancementEnabled =
    state?.AbTest && getABtestFromState(state.AbTest).isSearchEnhancementRedesignEnabled;
  return isSearchEnhancementEnabled || true;
};

export const getABTestIsEnhancedWebSearchBarEnabled = (state) => {
  const isEnhancedWebSearchEnabled =
    state?.AbTest && getABtestFromState(state.AbTest).isEnhancedWebSearchBarEnabled;
  return isEnhancedWebSearchEnabled || true;
};

export const getABTestIsSearchBarAutosuggestProductsEnabled = (state) => {
  return state?.AbTest && getABtestFromState(state.AbTest).isSearchBarAutosuggestProductsEnabled;
};

export const getIsROKTEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_ROKT_ENABLED);
});

export const getDisableROKTAbTest = (state) => {
  return state?.AbTest && getABtestFromState(state.AbTest).disableROKT;
};

export const getIsHorizontalPlpEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.IS_HORIZONTAL_PLP_ENABLED)
  );
};

export const getIsHorizontalPlpEnabledApp = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.IS_HORIZONTAL_PLP_ENABLED_APP)
  );
};

export const getIsPromoMsgEnabledRecommendation = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.IS_PROMO_MSG_ENABLED_RECOMMENDATION)
  );
};

export const getIsATBIconEnabled = (state) => {
  const { addToBagIconInPLP } = getABtestFromState(state.AbTest);
  if (typeof addToBagIconInPLP === 'undefined') {
    // check last value of session storage and return it
    if (typeof window !== 'undefined') {
      const sessionItem = getSessionStorage('addToBagIconInPLP');
      return parseBoolean(sessionItem);
    }
    return parseBoolean(addToBagIconInPLP);
  }
  // update session storage with new value and return the new value
  if (typeof window !== 'undefined') {
    setSessionStorage({ key: 'addToBagIconInPLP', value: addToBagIconInPLP });
  }
  return parseBoolean(addToBagIconInPLP);
};

export const getHorizontalCarouselPLPCatIds = createSelector(getSiteDetails, (siteDetails) =>
  extractDataFromString(siteDetails.CATEGORIES_FOR_HPLP, COMMA_DELIMITER)
);

export const getOutfitCarouselPillCategoryIds = createSelector(getSiteDetails, (siteDetails) => {
  return extractDataFromString(siteDetails.OUTFIT_PILL_VARIATION_CATEGORIES, COMMA_DELIMITER);
});

export const getBopisMultipleStoreEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_BOPIS_MULTIPLE_STORES_ENABLED)
  );
};

export const getBossMultipleStoreEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_BOSS_MULTIPLE_STORES_ENABLED)
  );
};

export const getModalBopisStoreCount = (state) => {
  return parseInt(getSiteDetails(state).MODAL_BOPIS_STORE_COUNT, 10) || 100;
};

export const getIsNewNavigationImagesEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    !parseBoolean(
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_MOBILE_NAVIGATION_REDESIGN_ENABLED
    ) &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_NEW_NAVIGATION_IMAGES_ENABLED) &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_NEW_NAVIGATION_VIEW_ENABLED)
  );
};

export const getABTestForCMSTrendingSearches = (state, brand = getBrandInCaps()) => {
  const trendingSearch = `TRENDING_SEARCH_${brand}`;
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails[trendingSearch]
  );
};
export const getIsVMPBossEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_VMP_BOSS_ENABLED)
  );
};

export const getIsOutfitPLPEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_OUTFIT_PLP_ENABLED)
  );
};

export const getIsMiniPDPEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_MINI_PDP_ENABLED)
  );
};

export const getCurrentSiteLanguage = (state) => {
  return state[SESSIONCONFIG_REDUCER_KEY] && state[SESSIONCONFIG_REDUCER_KEY].siteDetails.language;
};

export const getABTestIsCSHAppEnabled = (state) => {
  return getABtestFromState(state.AbTest).isCSHAppEnabled;
};

export const getIsAfterPayEnabled = (state) => {
  const currentLang = getCurrentSiteLanguage(state);
  if (isCanada() || currentLang === 'es' || getIsInternationalShipping(state)) return false;

  const AbTests = getABtestFromState(state.AbTest);
  const disableBNPL = AbTests && AbTests.disableBNPLFeature;

  if (disableBNPL) {
    return false;
  }

  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_AFTERPAY_FEATURE_ENABLED)
  );
};

export const getAfterPayMinAmount = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails.AFTERPAY_MIN_ITEM_AMOUNT
  );
};

export const getAfterPayMinOrderAmount = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails.AFTERPAY_MIN_ORDER_AMOUNT
  );
};

export const getAfterPayMaxOrderAmount = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails.AFTERPAY_MAX_ORDER_AMOUNT
  );
};

export const getIsPaidNExpediteRefundEnable = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.PAID_EXPEDITE_REFUND_ENABLE)
  );
};

export const getIsImageIndicatorUpdateEnabled = (state) => {
  return parseBoolean(
    state?.[SESSIONCONFIG_REDUCER_KEY]?.siteDetails?.IS_IMAGE_INDICATOR_UPDATE_ENABLED
  );
};

export const getIsPaidNExpediteRefundEnableApp = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.PAID_EXPEDITE_REFUND_ENABLE_APP)
  );
};

export const getIsCSHAppEnabled = (state) => {
  const abTestIsCSHEnabled = getABTestIsCSHAppEnabled(state);
  if (abTestIsCSHEnabled) {
    return true;
  }
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.CSH_APP_ENABLED)
  );
};

export const getIsMuleLogonApiEnable = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.ENABLE_MULE_LOGON_API)
  );
};

export const getIsMuleResetPasswordEnable = (state) => {
  const apiConfigObj = getAPIConfig();
  const { isPhoneMSEnabled } = apiConfigObj;
  if (parseBoolean(isPhoneMSEnabled)) {
    return false;
  }
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.ENABLE_MULE_LOGON_API)
  );
};

export const getBootstrapError = (state) => {
  return state[SESSIONCONFIG_REDUCER_KEY] && state[SESSIONCONFIG_REDUCER_KEY].bootstrapError;
};

export const getIsPayPalEnabled = (state) => {
  const key = 'BOPIS_MIXCART_PAYPAL_ENABLED';
  return (
    state[SESSIONCONFIG_REDUCER_KEY] && state[SESSIONCONFIG_REDUCER_KEY].siteDetails[key] === 'TRUE'
  );
};

export const getIsLogonRecaptchaEnabled = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] && state[SESSIONCONFIG_REDUCER_KEY].siteDetails.LOGON_RECAPTCHA
  );
};

export const getIsEmailRecaptchaEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.EMAIL_RECAPTCHA_ENABLED);
});

export const getEmailRecaptchaThresold = createSelector(getSiteDetails, (siteDetails) => {
  return parseInt(siteDetails.EMAIL_RECAPTCHA_THRESHOLD || 3, 10);
});

export const getIsResetRecaptchaEnabled = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.RESET_PASSWORD_RECAPTCHA_ENABLED
  );
};

export const getIsSuppressGetOrderDetails = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.SUPPRESS_GETORDERDETAILS_WITH_ATC_BRIERLEY
  );
};

export const getIsHamburgerMenuRedesignEnabled = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_HAMBURGER_MENU_REDESIGN_ENABLED
  );
};

export const getIsSFLEnabledApp = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] && state[SESSIONCONFIG_REDUCER_KEY].siteDetails.SFL_ENABLED_APP
  );
};

export const getIsInternationalCheckoutEnabled = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.INTERNATIONAL_CHECKOUT_ENABLED
  );
};

export const getIsSmsUpdatesEnabled = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.TRANS_VIBES_SMS_ENABLED
  );
};

export const getRegisteredUserInfoCachingInterval = (state) => {
  const cachingTTL =
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails.GETREGDUSERINFO_CACHING_INTERVAL;
  if (typeof cachingTTL !== 'undefined') {
    return parseInt(cachingTTL, 10);
  }

  return cachingTTL;
};

export const getIsRecapchaEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.GIFT_CARD_RECAPTCHA_ENABLED)
  );
};

export const getABTestIsShowPriceRange = (state) => {
  return getABtestFromState(state.AbTest).getPriceRange;
};

export const getABTestAppCategoryCarouselL3 = (state) => {
  return getABtestFromState(state.AbTest).appCategoryCarouselL3;
};

export const getDisableGymCrossBrandL1 = (state) => {
  return getABtestFromState(state.AbTest).disableGymCrossBrandL1;
};

export const getABTestAddToBagDrawer = (state) => {
  return getABtestFromState(state.AbTest).addToBagDrawerFlag;
};

export const getSuppressATBplpABTestEnabled = (state) => {
  return getABtestFromState(state.AbTest).isSuppressATBplpABTestEnabled;
};

export const getSuppressATBpdpABTestEnabled = (state) => {
  return getABtestFromState(state.AbTest).isSuppressATBpdpABTestEnabled;
};

export const getSuppressATBbagPageABTestEnabled = (state) => {
  return getABtestFromState(state.AbTest).isSuppressATBbagPageABTestEnabled;
};

export const getABTestPdpService = (state) => {
  return getABtestFromState(state.AbTest).enablePDPService;
};

export const getABTestSwapMpackPills = (state) => {
  return getABtestFromState(state.AbTest).disableSwappingMpackPills;
};

export const getIsShowPriceRange = (state) => {
  return state.session && parseBoolean(state.session.siteDetails.PRICE_RANGE_SWITCH);
};

export const getIsAutoSaveOnLoginEnabled = (state) => {
  return state.session && parseBoolean(state.session.siteDetails.IS_FAV_AUTO_SAVE_ON_LOGIN_ENABLED);
};

export const getIsAutoSaveOnLoginEnabledApp = (state) => {
  return (
    state.session && parseBoolean(state.session.siteDetails.IS_FAV_AUTO_SAVE_ON_LOGIN_ENABLED_APP)
  );
};

export const getIsExtendedDisplay = createSelector(
  getSiteDetails,
  (state) => getABtestFromState(state.AbTest),
  (siteDetails, abTests) => {
    return (
      parseBoolean(siteDetails.IS_EXTENDED_DISPLAY_SWITCH) && !abTests?.isHidePLPExtendedDisplay
    );
  }
);

export const getIsSessionSharingEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.IS_SESSION_SHARING_ENABLED)
  );
};

export const getMultiPackThreshold = (state) => {
  return state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.MULTIPACK_INVENTORY_THRESHOLD
    ? state.session.siteDetails.MULTIPACK_INVENTORY_THRESHOLD
    : false;
};

export const getCollectionOutfitCatId = (state) => {
  return state?.session?.siteDetails?.COLLECTION_OUTFIT_CATID;
};

export const getIsShowPriceRangeForApp = (state) => {
  return state.session && state.session.siteDetails.PRICE_RANGE_SWITCH_APP;
};

export const getPreviewDate = (state) => state && state.APIConfig && state.APIConfig.previewDate;

export const downloadAppPromoEnabledFooter = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.IS_APP_DOWNLOAD_FOOTER_ENABLED)
  );
};

export const getIsDisplayPickupTimeEnabled = (state) => {
  return parseBoolean(state?.session?.siteDetails?.IS_DISPLAY_PICKUP_TIME_ENABLED);
};

export const getStoreHoursThreshold = (state) => {
  return parseInt(state?.session?.siteDetails?.STORE_HOURS_THRESHOLD, 10);
};

export const getIsFullDateDisplayEnabled = (state) => {
  return parseBoolean(state?.session?.siteDetails?.IS_FULL_DATE_DISPLAY_ENABLED);
};

export const getIsFacetedNavigationEnabled = (state) => {
  return parseBoolean(state?.session?.siteDetails?.IS_FACETED_NAVIGATION_SEO_ENABLED);
};

export const getSeoFacetedNavigationConfig = createSelector(
  (state) => state?.session?.siteDetails?.IS_FACETED_NAVIGATION_SEO_ENABLED,
  (state) => state?.session?.siteDetails?.SEO_FACETED_NAVIGATION_CONFIG,
  (isFacetedNavigationSeoEnabled, seoFacetedNavigationConfig) => {
    if (parseBoolean(isFacetedNavigationSeoEnabled) && seoFacetedNavigationConfig) {
      return safelyParseArray(seoFacetedNavigationConfig);
    }
    return [];
  }
);

export const getIsCleanUrlForSizeEnabled = (state) => {
  const siteDetails = state?.session?.siteDetails;
  return (
    parseBoolean(siteDetails?.IS_FACETED_NAVIGATION_SEO_ENABLED) &&
    parseBoolean(siteDetails?.IS_CLEAN_URL_FOR_SIZE_ENABLED)
  );
};

export const getAppBanner = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.IS_APP_BANNER_ENABLED)
  );
};

/**
 * @description get coupons timeout value from the xapp config in minutes, default is 15 for qa testing.
 * @param {object} state
 */
export const getCouponsTimeout = (state) =>
  (state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.COUPONS_UPDATE_TIMEOUT) ||
  15;

export const getIsBagCarouselEnabled = (state) => {
  return getABtestFromState(state.AbTest).isHomeBagCarosuelABTest;
};

export const getIsCategoryCarouselEnabled = (state) => {
  return getABtestFromState(state.AbTest).isHomeCategoryCarouselABTest;
};

export const getIsPlpCategoryFiltersEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.IS_PLP_CATEGORY_FILTERS_ENABLED)
  );
};

export const getIsNewPlpCardTileEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.IS_NEW_PLP_CARD_TILE_ENABLED)
  );
};

export const getIsNewPlpImageBorderEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.IS_PLP_IMAGE_BORDER_ENABLED)
  );
};

export const getIsNewPJPPDPRedesignEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.IS_NEW_PJP_PDP_REDESIGN_ENABLED)
  );
};

export const getIsPDPRedesignEnabled = createSelector(
  getSiteDetails,
  (state) => getABtestFromState(state.AbTest),
  (siteDetails, abTests) => {
    return (
      parseBoolean(siteDetails.IS_PDP_REDESIGN_ENABLED) &&
      !parseBoolean(abTests?.disablePdpRedesign)
    );
  }
);

export const getIsPickupPromotionPDPEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_PICKUP_PROMOTION_PDP_ENABLED);
});

export const getIsSuppressOOSFitsEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_SUPPRESS_OOS_FITS_ENABLED);
});

export const getIsFooterRedesignEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_FOOTER_REDESIGN_ENABLED);
});

export const getIsCollectionsZoomEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_COLLECTIONS_ZOOM_ENABLED);
});

export const getIsPerUnitPriceEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.IS_PHYSICAL_MULTIPACK_ENABLED) &&
    parseBoolean(state.session.siteDetails.IS_PER_ITEM_PRICE_ENABLED)
  );
};

export const getIsCompleteTheLookTestEnabled = (state) => {
  return getABtestFromState(state.AbTest).pdpMobileWebDesign;
};
export const getCategoryFilterEnabledList = (state) => {
  return getABtestFromState(state.AbTest).plpSubCategoryFilters;
};

export const getIsAvoidGetOrderDetails = (state) => {
  const isInternationalShipping = getIsInternationalShipping(state);
  const reducerKeyATB = 'IS_STORE_ATB_DETAILS_ENABLED';
  return (
    parseBoolean(
      state &&
        state[SESSIONCONFIG_REDUCER_KEY] &&
        state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
        state[SESSIONCONFIG_REDUCER_KEY].siteDetails[reducerKeyATB]
    ) && !isInternationalShipping
  );
};

export const getCartIconCheckoutNavigationABTest = (state) => {
  return getABtestFromState(state.AbTest).hideCartIconCheckoutNavigation;
};

export const getIsChangeRecalForEcom = (state) => {
  return parseBoolean(
    state &&
      state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails
        .CART_PAGE_RECALC_FOR_ECOM_AFTER_TIME_PERIOD_ENABLED
  );
};

export const getStoreSearchTypesParam = (state) => {
  return (
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails.mapboxStoreSearchTypesParam
  );
};

export const getIsBopisOptionSelected = (state) => {
  return state.PickupModal && state.PickupModal.get('isBopisPickup');
};

export const getIsBossEditSelected = (state) => {
  return state.PickupModal && state.PickupModal.get('isBossPickupEdit');
};

export const getAutocompleteTypesParam = (state) => {
  return (
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails.mapboxAutocompleteTypesParam
  );
};

export const getMapboxSwitch = (state) => {
  return parseBoolean(
    state &&
      state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.mapboxSwitch
  );
};

export const getDynamicPromoPerfSwitch = (state) => {
  return parseBoolean(
    state &&
      state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.PDP_DYNAMIC_PROMO_PERF_SWITCH
  );
};

export const getFlipSwitchState = (state) => {
  return parseBoolean(
    state &&
      state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_UNBXD_FAILOVER_ENABLED
  );
};

export const getBundlePageRedesign = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return !parseBoolean(abTests?.isBundlePageRedesignEnabled);
  }
);

export const getDynamicContentPDP = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return !parseBoolean(abTests?.isDynamicContentPDPEnabled);
  }
);

export const getUnbxdDRUrlState = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails.UNBXD_FAILOVER_DOMAIN
  );
};

export const getABTestOffStyleWith = (state) => {
  return parseBoolean(getABtestFromState(state.AbTest).disableStyleWithSectionATB);
};

export const getIsPhysicalMpackEnabled = (state) => {
  return parseBoolean(
    state &&
      state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_PHYSICAL_MULTIPACK_ENABLED
  );
};

export const getMultiColorNameEnabled = (state) => {
  return parseBoolean(
    state &&
      state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_MULTI_COLOR_NAME_ENABLED
  );
};

export const getFetchClosestStore = (state) => {
  return parseBoolean(
    state &&
      state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.FETCH_CLOSEST_STORE
  );
};
export const getSwitchToSfccForStoreInfo = (state) => {
  return parseBoolean(
    state &&
      state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.SWITCH_TO_SFCC_FOR_STORE_INFO
  );
};

export const getStoreLocatorMapboxApi = (state) => {
  return parseBoolean(
    state &&
      state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.STORE_LOCATOR_STORES_MAPBOX_API
  );
};

export const getStoreLocatorMapboxTileIDs = (state) => {
  const { storeDetailViewMapKey } = getAPIConfig();
  const lowEnvUrl = parseBoolean(storeDetailViewMapKey)
    ? 'childrensplace.store-locator-all'
    : 'childrensplace.store-locator';
  return (
    (state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.STORE_LOCATOR_STORES_TILESET_ID) ||
    lowEnvUrl
  );
};

export const getIsPlpPdpAnchoringEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_PLP_PDP_ANCHORING_ENABLED &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_PLP_PDP_ANCHORING_ENABLED)
  );
};

export const getIsSLPPersistEnabled = (state) => {
  return state && state.AbTest && state.AbTest.isRelatedSearchSLPABTest;
};

export const getIsLastPurchasedEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return parseBoolean(abTests?.isLastPurchasedEnabled);
  }
);

export const getIsDidYouMeanEnabled = (state) => {
  return state && state.AbTest && state.AbTest.isDidYouMeanAbTest;
};

export const getisQvPdpInfluencerHandleAbTest = (state) => {
  return (
    getABtestFromState(state.AbTest) &&
    getABtestFromState(state.AbTest).isQvPdpInfluencerHandleAbTest
  );
};

export const getBundleOutfitInfluencerHandleAbTest = (state) => {
  return (
    getABtestFromState(state.AbTest) &&
    getABtestFromState(state.AbTest).isBundleOutfitInfluencerHandleAbTest
  );
};

export const getInfluencerPicksEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_INFLUENCER_PICKS_ENABLED)
  );
};

export const getIsHplpCmsSbcEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_HPLP_CMS_SBC_ENABLED)
  );
};

export const getIsHplpCmsSbcEnabledApp = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_HPLP_CMS_SBC_ENABLED_APP)
  );
};

export const getIsImageSwatchDisabled = (state) => {
  return state && state.AbTest && state.AbTest.imageSwatchABTest;
};

export const getIsStsCtaEnabled = (state) => {
  return state && state.AbTest && state.AbTest.isShopThisStoreCtaEnabled;
};

export const getIsChatBotEnabled = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_CHAT_BOT_ENABLED
  );
};
export const getABTestForChatBot = (state) => {
  return getABtestFromState(state.AbTest).chatBotABTest;
};

export const getCSHOlderMonth = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseInt(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.CSH_FOR_OLDER_MONTH, 10)
  );
};

export const getCSHReturnItemOlderDays = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseInt(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.CSH_FOR_INITIATE_RETURN_DAYS, 10)
  );
};

export const getIsSeoHeaderEnabled = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_SEO_HEADER_ENABLED
  );
};

export const getABTestForPDPColorOrImageSwatchHover = (state) => {
  const abTestFromState = getABtestFromState(state.AbTest);
  return abTestFromState && abTestFromState.changePDPPrimaryImageOnHover;
};

export const getIsBabyL2NestingDisabled = (state) => {
  return getABtestFromState(state.AbTest) && getABtestFromState(state.AbTest).disableBabyL2Nesting;
};

export const getIsABLoaded = (state) => {
  return state && state.AbTest && state.AbTest.abTestComplete;
};

export const getIsPersistPointsApiEnabled = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.ENABLE_FE_CALC_LOYALTY_POINTS
  );
};

export const getLoyaltyPointsMultiplier = (state) => {
  const siteDetails =
    (state[SESSIONCONFIG_REDUCER_KEY] && state[SESSIONCONFIG_REDUCER_KEY].siteDetails) || {};
  return {
    rewardsDollarPoints: parseInt(siteDetails.LOYALTY_POINTS_REWARD_POINTS || 100, 10),
    rewardsDollarAmount: parseInt(siteDetails.LOYALTY_POINTS_REWARD_AMOUNT || 5, 10),
    loyaltyMultiplier: parseInt(siteDetails.LOYALTY_MULTIPLIER || 1, 10),
    loyaltyPLCCMultiplier: parseInt(siteDetails.LOYALTY_PLCC_MULTIPLIER || 2, 10),
  };
};

export const getMonetateProductsRefreshTime = (state) => {
  return (
    (state &&
      state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.MONETATE_PLP_PRODS_REFRESH_TIME) ||
    900
  );
};

export const getUnbxdProductsRefreshFrequency = (state) => {
  return (
    (state &&
      state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.UNBXD_PLP_PRODS_REFRESH_FREQUENCY) ||
    60
  );
};

export const getIsCouponSelfHelpEnabled = (state) => {
  return (
    (state &&
      state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
      parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_CANNOT_APPLY_COUPON_ENABLED)) ||
    false
  );
};

export const getIsDynamicBadgeMPACKEnabled = (state) => {
  return (
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY]?.siteDetails?.IS_DYNAMIC_BADGE_ENABLED) || false
  );
};

export const getIsDynamicBadgeVirtualMPACKEnabled = (state) => {
  return (
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY]?.siteDetails?.IS_DYNAMIC_BADGE_VMPACK_ENABLED) ||
    false
  );
};

export const getIsDynamicBadgeSetEnabled = (state) => {
  return (
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY]?.siteDetails?.IS_DYNAMIC_BADGE_SET_ENABLED) ||
    false
  );
};

export const getIsDynamicBadgeVirtualSetEnabled = (state) => {
  return (
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY]?.siteDetails?.IS_DYNAMIC_BADGE_VSET_ENABLED) ||
    false
  );
};

export const getAsyncHomePageRecommendation = (state) => {
  return parseInt(state.session.siteDetails.ASYNC_HOMEPAGE_RECOMMENDATION, 10) || 0;
};

export const getIsDynamicBadgeEnabled = createSelector(
  getIsDynamicBadgeMPACKEnabled,
  getIsDynamicBadgeVirtualMPACKEnabled,
  getIsDynamicBadgeSetEnabled,
  getIsDynamicBadgeVirtualSetEnabled,
  (
    dynamicBadgeMPACKEnabled,
    dynamicBadgeVirtualMPACKEnabled,
    dynamicBadgeSetEnabled,
    dynamicBadgeVirtualSetEnabled
  ) => {
    return {
      dynamicBadgeMPACKEnabled,
      dynamicBadgeVirtualMPACKEnabled,
      dynamicBadgeSetEnabled,
      dynamicBadgeVirtualSetEnabled,
    };
  }
);

export const getIsDisableMultipackBadgeAbtest = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return parseBoolean(abTests?.isDisableMultipackBadge);
  }
);

export const getIsDisableSetBadgeAbtest = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return parseBoolean(abTests?.isDisableSetBadge);
  }
);

export const getIsDisableDynamicBadgeFlagAbtest = createSelector(
  getIsDisableMultipackBadgeAbtest,
  getIsDisableSetBadgeAbtest,
  (dynamicsBadgeMPACKEnabled, dynamicsBadgeSetEnabled) => {
    return {
      dynamicsBadgeMPACKEnabled,
      dynamicsBadgeSetEnabled,
    };
  }
);

export const getABTestForStickyFilter = (state) => {
  const abTestFromState = getABtestFromState(state.AbTest);
  return abTestFromState && abTestFromState.stickyFilterABTest;
};

export const getIsATBHidePoints = (state) => {
  const getAbtests = getABtestFromState(state.AbTest);
  return getAbtests && getAbtests.isHidePointsEnabled;
};

export const getCartsSessionStatus = (state) => {
  return (state && state.session && state.session.cartsSessionStatus) || 0;
};

export const getCheckoutMetricsStatus = (state, name) => {
  const metrics = (state && state.session && state.session.checkoutMetricsStatus) || {};
  if (metrics[name] >= 0) {
    return metrics[name];
  }
  return 1;
};

export const getIsShowNavAnimation = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_MICRO_ANIMATION_ENABLED
  );
};

export const getIsShowBagSimplifiedHeader = createSelector(
  getSiteDetails,
  (state) => getABtestFromState(state.AbTest),
  (siteDetails, abTests) => {
    return (
      parseBoolean(siteDetails.IS_SIMPLIFIED_HEADER_ON_BAG_ENABLED) &&
      abTests &&
      !abTests.isDisableBagSimplifiedHeader
    );
  }
);

export const getIsDisableBagAnchoring = (state) => {
  const getAbtests = getABtestFromState(state.AbTest);
  const isShowBagSimplifiedHeader = getIsShowBagSimplifiedHeader(state);
  return (getAbtests && getAbtests.isDisableBagAnchoring) || isShowBagSimplifiedHeader;
};

export const getIsNewReDesignEnabled = () => {
  return false;
};

export const getIsATBModalBackAbTestNewDesign = () => {
  return false;
};

export const getIsHapticFeedbackEnabled = () => {
  const { hapticFeedbackDisabled } = getAPIConfig();
  if (hapticFeedbackDisabled) {
    return false;
  }
  return true;
};

export const getIsRedesignedPdpDesktopView = (state) => {
  const getAbtests = getABtestFromState(state.AbTest);
  return getAbtests && !getAbtests.isHidePdpDesktopView;
};

export const getIsHiddenPDPAltImageEnabled = createSelector(
  getSiteDetails,
  getIsRedesignedPdpDesktopView,
  (siteDetails, isRedesignedPdpDesktopView) => {
    return parseBoolean(siteDetails.IS_PDP_DESKTOP_ALT_IMG_HIDDEN) && isRedesignedPdpDesktopView;
  }
);

export const getIsPDPSmoothScrollEnabled = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_PDP_SMOOTH_SCROLL_ENABLED
  );
};

export const getIsHpNewDesignCTAEnabled = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_HP_NEW_DESIGN_CTA_ENABLED
  );
};

export const getIsHpNewModuleDesignEnabled = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_HP_NEW_DESIGN_MODULE_ENABLED
  );
};

export const getIsHpOnScrollAnimationEnabled = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_HP_ONSCROLL_ANIMATION_ENABLED
  );
};

export const getIsViewThisLookLabelABTestEnabled = (state) => {
  const getAbtests = getABtestFromState(state.AbTest);
  return getAbtests && getAbtests.isViewThisLookLabelABTestEnabled;
};

export const getISHomeL2ShopCategoryABTestEnabled = (state) => {
  const getAbtests = getABtestFromState(state.AbTest);
  return getAbtests && getAbtests.ISHomeL2ShopCategory;
};

export const getIsHomePageCTLCarouselEnabled = (state) => {
  const getAbtests = getABtestFromState(state.AbTest);
  return getAbtests && getAbtests.isHomePageCTLCarouselEnabled;
};

export const getIsDepartmentCarouselEnabled = (state) => {
  const abTests = getABtestFromState(state.AbTest);
  return abTests && parseBoolean(abTests.isDepartmentCarouselEnabled);
};
export const getSearchReduxState = (state) => {
  return state && state.Search && state.Search.searchResults?.autosuggestList?.[0]?.searchTerm;
};
export const getPageNameFromState = (state) => {
  const pageName = (state && state.pageData && state.pageData.pageName) || 'account';

  if (pageName.includes('account') || pageName.includes('static')) return 'account';
  if (pageName.includes('shopping')) return 'cart';
  if (pageName.includes('appliction') || pageName.includes('application')) return 'account';
  if (pageName.includes('product:')) return 'pdp';
  if (pageName.includes('browse:')) return 'plp';
  if (pageName.includes('search:')) return 'search';
  if (pageName.includes('myplace:wallet')) return 'myplace:wallet';
  return pageName;
};

export const getCartCacheTTL = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails.CART_CACHE_TTL && parseFloat(siteDetails.CART_CACHE_TTL);
});

export const getDefaultShipmentTTL = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails.DEFAULT_SHIPMENT_TTL && parseFloat(siteDetails.DEFAULT_SHIPMENT_TTL);
});

export const getGiftOptionsTTL = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails.GIFT_OPTIONS_TTL && parseFloat(siteDetails.GIFT_OPTIONS_TTL);
});
export const getIsLiveChatEnabled = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.LIVE_CHAT_ENABLED
  );
};

export const getIsMobileLiveChatEnabled = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.LIVE_CHAT_ENABLED_APP
  );
};
export const getIsMergeMyPlaceAccount = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.MERGE_MY_PLACE_ACCOUNT_ENABLED
  );
};

export const getIsGiftCardBalance = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.EGIFTCARD_BALANCE_CHECK_ENABLED
  );
};

export const getIsLiveChatBackABisOff = (state) => {
  const getAbtests = getABtestFromState(state.AbTest);
  return !(getAbtests && getAbtests.isLiveChatDisabled);
};

export const getIsNewLoyaltyBanner = (state) => {
  const getAbtests = getABtestFromState(state.AbTest);
  return getAbtests && getAbtests.enablePlccOffBag;
};
export const getIsNonInventoryABTestEnabled = (state) => {
  const getAbtests = getABtestFromState(state.AbTest);
  return getAbtests && getAbtests.isNonInventoryABTestEnabled;
};
export const getQuickAddThreshold = (state) => {
  return parseInt(getSiteDetails(state).QUICK_ADD_THRESHOLD, 10) || 0;
};
export const getOptimisticAddBagModal = (state) => {
  return parseInt(getSiteDetails(state).IS_OPTIMISTIC_ADD_TO_BAG, 10) || 0;
};
export const getTrendingSearchState = (state) => {
  return state?.Search?.trendingResults;
};

export const getAbTestIsFamilyOutfitRightViewEnabled = (state) => {
  return state?.AbTest && getABtestFromState(state.AbTest).isFamilyOutfitRightViewEnabled;
};

export const getIsTakeDownRedirectionEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.IS_TAKEDOWN_REDIRECTION_ENABLED)
  );
};

export const getIsColorConsolidationEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.IS_COLOR_CONSOLIDATION_ENABLED)
  );
};

const getIsLowInventoryBanner = (state) => {
  const getAbtests = getABtestFromState(state.AbTest);
  return getAbtests && getAbtests.isLowInventoyBannerAbTest && isTCP() && isUsOnly();
};

export const getIsShowLowInventoryBanner = (state) => {
  return getIsLowInventoryBanner(state);
};

export const getIsShowLowInventoryBannerForOldDesign = (state) => {
  return getIsLowInventoryBanner(state);
};

export const getIsNonInvSessionFlag = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.stageNonInventorySessionFlag
  );
};

export const getIsShowBrandNameEnabled = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_SHOW_BRAND_NAME_ENABLED
  );
};

export const getIsNewWhenWillMyOrderArriveEnabled = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_WHEN_WILL_MY_ORDER_ARRIVE_ENABLED
  );
};

/**
 *
 * @function getIsSingleAddToBagAPIEnabled
 * @param {*} state
 * @description this selector gives is single multi add to bag API is enabled
 */
export const getIsSingleAddToBagAPIEnabled = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails
        .ENABLE_ADDING_MULTILE_ITEMS_TO_BAG_IN_ONE_API_CALL
  );
};

export const getIsOtherBrandExpABTestEnabled = (state) => {
  const getAbtests = getABtestFromState(state.AbTest);
  return getAbtests && getAbtests.isOtherBrandExpABTestEnabled;
};

export const getNullSearchCatId = (state, brand, alternateSearchBrand) => {
  let categoryIds = '';
  const flag = `NULL_SEARCH_CAT_ID_${brand.toUpperCase()}_${alternateSearchBrand.toUpperCase()}`;
  categoryIds =
    state?.[SESSIONCONFIG_REDUCER_KEY] && state?.[SESSIONCONFIG_REDUCER_KEY]?.siteDetails?.[flag];
  return categoryIds;
};

export const getIsHideStickyCheckoutButton = (state) => {
  const getAbtests = getABtestFromState(state.AbTest);
  return getAbtests && getAbtests.isHideStickyCheckoutAbTest;
};

export const getCreateAccountAfterGuestUserApplyForPLCCCard = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails
        .CREATE_ACCOUNT_AFTER_GUEST_USER_APPLY_FOR_PLCC_CARD
  );
};

export const getBirthdaySavingsCallEnabled = (state) => {
  return parseInt(getSiteDetails(state).CALL_GET_BIRTHDAY_SAVING_SERVICE_ON_APP_LOAD, 10) || 0;
};

export const getIsShopThisStoreEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_SHOP_THIS_STORE_ENABLED)
  );
};

export const getIsNewSwatchURLEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_NEW_SWATCH_URL_ENABLED)
  );
};

export const getIsOutfitNewDesignEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_OUTFIT_NEW_DESIGN_ENABLED)
  );
};

export const getIsBundleNewDesignEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_BUNDLE_NEW_DESIGN_ENABLED)
  );
};

export const getIsCombinedKitEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_COMBINED_KIT_ENABLED)
  );
};

export const getIsBrandTutorialEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.SHOW_SWITCH_BRAND_TUTORIAL_APP)
  );
};

export const getIsAlternateImageOnHoverEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_ALTERNATE_IMAGE_ON_HOVER_ENABLED)
  );
};

export const getIsMainPromoSplashEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_APP_MAIN_PROMO_SPLASH_ENABLED)
  );
};

export const getIsPickupNotificationDrawerEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_BOSS_PICKUP_NOTIFICATION_DRAWER_ENABLED
    )
  );
};

export const getIsSecondaryLoyaltyComponentEnabledApp = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_SECONDARY_LOYALTY_COMP_ENABLED)
  );
};

export const getNewPricingComponentEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_NEW_PRICING_COMPONENT_ENABLED_APP)
  );
};

export const getNewZoneOneBadgeEnabledApp = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.ENABLE_NEW_ZOME_ONE_BADGE_APP)
  );
};

export const getIsSuppressATBModelEnabledApp = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.ENABLE_SUPPRESS_ATB_MODAL_APP)
  );
};

export const getIsSiteMaintenancePopUpEnabledApp = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.SITE_MAINTENANCE_POPUP_ENABLED_APP)
  );
};

export const getNonEligibleForCouponsEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.PRODUCTS_NON_ELIGIBLE_FOR_COUPONS_ENABLED_APP
    )
  );
};

export const isShopThisStoreModeOn = () => {
  return (
    getIsShopThisStoreEnabled(getStoreRef()?.getState()) &&
    (getUrlParameter('mode') === SHOP_THIS_STORE_URL_QUERY_KEY ||
      checkForKeyInURL(SHOP_THIS_STORE_URL_QUERY_KEY))
  );
};

export const getBotCategortIds = () => {
  const state = getStoreRef()?.getState();
  return (
    state &&
    extractDataFromString(
      state[SESSIONCONFIG_REDUCER_KEY]?.siteDetails?.CATEGORIES_FOR_BOTS,
      COMMA_DELIMITER
    )
  );
};

export const getIsHardcodeSizeMapEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_HARDCODE_SIZE_MAP_ENABLED)
  );
};

const getHardcodeSizeMapConfigSelector = (state) => {
  return state && state[SESSIONCONFIG_REDUCER_KEY] && state[SESSIONCONFIG_REDUCER_KEY].siteDetails;
};

// fix for cartItemTile re-endering on cart and checkout page
export const getHardcodeSizeMapConfig = createSelector(
  getHardcodeSizeMapConfigSelector,
  (siteDetails) => {
    return safelyParseJSON(siteDetails.HARDCODE_SIZE_MAP_CONFIG);
  }
);

export const getIsBopisFilterEnabled = (state) => {
  if (isShopThisStoreModeOn()) return false;
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.IS_BOPIS_FILTER_DISPLAY_ENABLED)
  );
};

export const getIsPaginationViewEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.IS_PAGINATION_VIEW_ENABLED)
  );
};

export const getIsHideMeatBallMenuAbTest = (state) => {
  const getAbtests = getABtestFromState(state.AbTest);
  return getAbtests && (getAbtests.isShowCTAAbTest || getAbtests.isShowEditCTAAbTest);
};

export const getIsShowEditCTAAbTest = (state) => {
  const getAbtests = getABtestFromState(state.AbTest);
  return getAbtests && getAbtests.isShowEditCTAAbTest;
};

export const getIsFBTAbTestEnabled = (state) => {
  const getAbtests = getABtestFromState(state.AbTest);
  return getAbtests && getAbtests.enableFBTabTest;
};

export const getIsStickyPaymentAbTestEnabled = (state) => {
  const getAbtests = getABtestFromState(state.AbTest);
  return (
    (getAbtests && getAbtests.enableStickyPaymentAbTest && !getIsInternationalShipping(state)) ||
    false
  );
};

export const getIsStickyCheckoutAbTestEnabled = (state) => {
  const getAbtests = getABtestFromState(state.AbTest);
  return (
    (getAbtests && getAbtests.enableStickyCheckoutAbTest && !getIsInternationalShipping(state)) ||
    false
  );
};

export const getIsResetViaText = (state) => {
  return (
    parseBoolean(
      state[SESSIONCONFIG_REDUCER_KEY] &&
        state[SESSIONCONFIG_REDUCER_KEY].siteDetails.RESET_PASSWORD_SMS_OTP_ENABLED
    ) && isUsOnly()
  );
};

export const getSBPHomepageCarouselABTestEnabled = (state) => {
  const getAbtests = getABtestFromState(state.AbTest);
  return getAbtests && getAbtests.SHOP_BY_PROFILE_HOMEPAGE_CAROUSEL_ENABLED;
};
export const getIsAddedToBagRedesignEnabled = (state) => {
  const getAbtests = getABtestFromState(state.AbTest);
  return !(getAbtests && getAbtests.isAddedToBagRedesignBackAB);
};

export const getIsTransparentImageSizeReduced = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.TRANSPARENT_IMAGE_SIZE_REDUCE_ENABLED);
});

export const getIsTransparentImageSizeReducedForPdp = createSelector(
  getSiteDetails,
  (siteDetails) => {
    return parseBoolean(siteDetails.TRANSPARENT_IMAGE_SIZE_REDUCE_ENABLED_PDP);
  }
);

export const getIsBuyMorePromoEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.BUY_MORE_SAVE_MORE_ENABLED)
  );
};

export const getIsCollectionSeoForPlpEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.COLLECTION_SEO_PLP_ENABLED)
  );
};

export const getIsOffersDisplayEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.IS_OFFERS_DISPLAY_ENABLED)
  );
};

export const getIsShowShipToHomeEddEnabled = (state) => {
  return (
    state &&
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.SHOW_SHIP_TO_HOME_EDD &&
    parseBoolean(state.session.siteDetails.SHOW_SHIP_TO_HOME_EDD)
  );
};

export const getIsBuyMorePromoOnRecommendationEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.BUY_MORE_SAVE_MORE_RECOMMENDATIONS)
  );
};

export const estimatedTaxBagPageEnabled = (state) => {
  return state && state[SESSIONCONFIG_REDUCER_KEY] && state[SESSIONCONFIG_REDUCER_KEY].siteDetails;
};

export const newMsEstimatedTax = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.ESTIMATED_TAX_NEW_MS_ENABLED)
  );
};

export const estimatedTaxReduxTTL = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails.ESTIMATED_TAX_REDUX_TTL
  );
};

export const getIsAccessoryEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.ACCESSORY_ENABLED)
  );
};
export const getIsBundleTrackerEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.BUNDLE_TRACKER_ENABLED)
  );
};

export const getIsStickyAtbHeader = (state) => {
  const getAbtests = getABtestFromState(state.AbTest);
  return getAbtests?.isStickyAtbHeader;
};

// kill switch for enabling addEmailSignup mule api
export const getWcsSubscribeEmailEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    !parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.ADD_SIGNUP_EMAIL_SFCC_ENABLED)
  );
};

export const multiDeviceEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.MULTI_DEVICE_ENABLED)
  );
};

export const disableVideosForAppleDevice = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_DISABLE_VIDEOS_FOR_APPLE
  );
};

export const getIsSlpDesktopView = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return !abTests?.isHideSLPExtendedDisplay;
  }
);

export const getIsEstimatedTotalOnBag = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return !abTests?.isNewEstimatedTotalOnBag;
  }
);

export const getRtpsModalThreshold = createSelector(getSiteDetails, (siteDetails) => {
  return parseInt(siteDetails.BROWSE_RTPS_MODAL_THRESHOLD || 0, 10);
});

export const getIsRtpsModalEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return abTests?.isRtpsModalEnabled;
  }
);

export const getIsRtpsBrowsePrescreenEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.BROWSE_RTPS_PRESCREEN_ENABLED);
});

export const getIsReloadOnInactivity = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_RELOAD_ON_INACTIVITY
  );
};

export const getIsReloadOnInactivityPostSpecifiedTime = (state) => {
  return parseBoolean(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_RELOAD_ON_INACTIVITY_POST_SPECIFIED_TIME
  );
};

export const getTimeToReloadPageInEST = (state) => {
  return (
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails.TIME_TO_RELOAD_PAGE_IN_EST &&
    ` ${state[SESSIONCONFIG_REDUCER_KEY].siteDetails.TIME_TO_RELOAD_PAGE_IN_EST.trim()}`
  );
};

export const getInActivityTimeInterval = (state) => {
  return parseInt(
    state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.INACTIVITY_TIME_IN_MS,
    10
  );
};

/**
 *
 * @function isNewSearchVenderEnabled
 * @param {*} state
 * @description This selector will suggest wheayre new search vendor is enabled or not
 */
export const isNewSearchVenderEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_NEW_SEARCH_VENDOR_ENABLED)
  );
};

export const isRatingsReviewsRedesignEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_RATINGS_REVIEWS_REDESIGN_ENABLED)
  );
};

export const getIsPLPImageHeightBasedOnAspectRatio = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_PLP_IMAGE_HEIGHT_BASED_ON_ASPECT_RATIO
    )
  );
};

export const getExtendedPreOrderValue = (state) => {
  return (
    (state &&
      state[SESSIONCONFIG_REDUCER_KEY] &&
      parseInt(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.EXTENDED_ORDER_VALUE, 10)) ||
    0
  );
};

export const getIsCrossBrandMerchandisingEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_CROSS_BRAND_MERCHANDISING_ENABLED)
  );
};

export const getBOSSOrderStatusEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.SHOW_BOSS_ORDER_STATUS)
  );
};

export const getIsNewHelpCenterEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_NEW_HELP_CENTER_ENABLED)
  );
};

export const getIsReferFriendDisabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_REFER_FRIEND_DISABLED)
  );
};

export const isRecommendationFromMonetateEnabledApp = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_RECOMMENDATION_FROM_MONETATE_ENABLED_APP
    )
  );
};

export const isRecommendationFromMonetateEnabledWeb = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_RECOMMENDATION_FROM_MONETATE_ENABLED_WEB
    )
  );
};

export const getIsNewPlpPaginatorEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_NEW_PLP_PAGINATOR_ENABLED)
  );
};

// Syte Vendor Feature Flag - Discovery Button
export const getIsSyteEnabled = (state) => {
  return getABtestFromState(state.AbTest)?.getIsSyteEnabled;
};

// Syte Vendor Feature Flag - Recommendations
export const getSyteRecommendations = (state) => {
  return getABtestFromState(state.AbTest)?.getSyteRecommendations;
};

export const getIsCaptchaEnabledOnMyAccount = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.MYACCOUNT_CREDIT_CARD_RECAPTCHA_ENABLED
    )
  );
};

export const getIsCaptchaEnabledOnCheckout = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.CHECKOUT_CREDIT_CARD_RECAPTCHA_ENABLED
    )
  );
};

export const getNumberOfProductsPerPage = createSelector(getSiteDetails, (siteDetails) => {
  const { isTablet = false, isMobile = false } = getViewportInfo() || {};
  if (isMobile) {
    return parseInt(
      siteDetails.NUMBER_OF_PRODUCTS_PER_PAGE_MOBILE_WEB || DEFAULT_PRODUCTS_PER_PAGE,
      10
    );
  }
  if (isTablet) {
    return parseInt(
      siteDetails.NUMBER_OF_PRODUCTS_PER_PAGE_TAB_WEB || DEFAULT_PRODUCTS_PER_PAGE,
      10
    );
  }
  return parseInt(siteDetails.NUMBER_OF_PRODUCTS_PER_PAGE || DEFAULT_PRODUCTS_PER_PAGE, 10);
});

export const getNumberOfProductsPerAPLPRow = createSelector(getSiteDetails, (siteDetails) => {
  return parseInt(siteDetails.NUMBER_OF_PRODUCTS_PER_APLP_ROW || 4, 10);
});

export const getInitialSubCategoryToLoad = createSelector(getSiteDetails, (siteDetails) => {
  return parseInt(siteDetails.MIN_INITIAL_HLP_SUBCAT_COUNT || 2, 10);
});

export const getSubCategoryToLoadOnScroll = createSelector(getSiteDetails, (siteDetails) => {
  return parseInt(siteDetails.SUBCAT_COUNT_TO_LOAD_ON_SCROLL || 2, 10);
});

export const getNumberOfProductsPerHLPRow = createSelector(getSiteDetails, (siteDetails) => {
  return parseInt(siteDetails.NUMBER_OF_PRODUCTS_PER_HLP_ROW || 8, 10);
});

export const getIsRecommendationProductInformationDisplay = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_RECOMMENDATION_PRODUCTINFO_ENABLED)
  );
};

export const getIsGuestRegisteredCallEnabled = (state) => {
  const apiConfigObj = getAPIConfig();
  const { isGuestRegisterCallEnabled } = apiConfigObj;
  if (parseBoolean(isGuestRegisterCallEnabled)) {
    return true;
  }
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_GUEST_REGISTERED_CALL_ENABLED)
  );
};

export const getIsSizeGroupFilterEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.SIZE_GROUP_FILTER_ENABLED)
  );
};

// Feature Flag - PDP - Similar Item to Consider
export const getIsSimilarItemToConsiderEnabled = (state) => {
  return getABtestFromState(state.AbTest)?.getIsSimilarItemToConsiderEnabled;
};

export const getIsAlternatePLPEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_ALTERNATE_PLP_ENABLED)
  );
};
export const getIsPaginatedAlternatePLPEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_PAGINATED_APLP_ENABLED)
  );
};

export const getPaginatedAlternatePLPCatIds = createSelector(getSiteDetails, (siteDetails) =>
  extractDataFromString(siteDetails.CATEGORIES_FOR_PAGINATED_APLP, COMMA_DELIMITER)
);

export const getAlternatePLPCatIds = createSelector(getSiteDetails, (siteDetails) =>
  extractDataFromString(siteDetails.CATEGORIES_FOR_APLP, COMMA_DELIMITER)
);

export const getTrendingInCategoryCarouselCatIds = createSelector(getSiteDetails, (siteDetails) =>
  extractDataFromString(siteDetails.CATEGORIES_FOR_TRENDING_IN_CATEGORY_CAROUSEL, COMMA_DELIMITER)
);

export const getAppPlpProductsPerLoad = () => {
  return PRODUCTS_PER_LOAD;
};

export const getIsBopisInventorySwitch = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.KILL_SWITCH_GET_BOPIS_INVENTORY)
  );
};

export const getIsUserPersonalizationEnabled = (state) => {
  return state &&
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.IS_USER_PERSONALIZATION_ENABLED
    ? parseBoolean(state.session.siteDetails.IS_USER_PERSONALIZATION_ENABLED)
    : false;
};

export const getUserPersonalizationRefreshTime = (state) => {
  return state &&
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.USER_PERSONALIZATION_REFRESH_TIME_IN_MS
    ? parseInt(state.session.siteDetails.USER_PERSONALIZATION_REFRESH_TIME_IN_MS, 10)
    : 0;
};

export const getUserPersonalizationApiEnabled = (state) => {
  return state &&
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.IS_USER_PERSONALIZATION_API_ENABLED
    ? getIsUserPersonalizationEnabled &&
        parseBoolean(state.session.siteDetails.IS_USER_PERSONALIZATION_API_ENABLED)
    : false;
};

export const getSizeChartNewDesignEnabled = (state) => {
  return (
    state &&
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.SIZE_CHART_NEW_DESIGN_ENABLED &&
    parseBoolean(state.session.siteDetails.SIZE_CHART_NEW_DESIGN_ENABLED)
  );
};

// Feature Flag - PLP - Category Pills - DRP-34607
export const getIsPLPCategoryPillsEnabled = (state) => {
  return getABtestFromState(state.AbTest)?.getIsPLPCategoryPillsEnabled;
};

export const getHolidayMessage = (state) => {
  return state &&
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.IS_HOLIDAY_MESSAGE_ENABLED
    ? parseBoolean(state.session.siteDetails.IS_HOLIDAY_MESSAGE_ENABLED)
    : false;
};

export const getEnableNativeContentUiHome = (state) => {
  return (
    state &&
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.ENABLE_NATIVE_CONTENT_UI_HOME &&
    parseBoolean(state.session.siteDetails.ENABLE_NATIVE_CONTENT_UI_HOME)
  );
};

export const getSortByRatingLabel = (state) => {
  return state &&
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.SORT_BY_RATINGS
    ? `${state.session.siteDetails.SORT_BY_RATINGS} desc`
    : 'TCPBazaarVoiceRating desc';
};

export const getAbTestIsNewPlpPaginatorShowingResultEnabled = (state) => {
  return getABtestFromState(state.AbTest).isNewPlpPaginatorShowingResultEnabled;
};

export const getStoreDrawerModeVisible = (state) => {
  return (
    state &&
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.IS_STOREDRAWER_MODE_ENABLED_APP &&
    parseBoolean(state.session.siteDetails.IS_STOREDRAWER_MODE_ENABLED_APP)
  );
};

export const getProductsPerPageMobile = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseInt(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.PRODUCTS_PER_PAGE_MOBILE, 10)
  );
};
export const getProductsPerPageTablet = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseInt(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.PRODUCTS_PER_PAGE_TABLET, 10)
  );
};
export const getProductsPerPageDesktop = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseInt(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.PRODUCTS_PER_PAGE_DESKTOP, 10)
  );
};
export const getProductsPerPageDefault = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseInt(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.PRODUCTS_PER_PAGE_DEFAULT, 10)
  );
};
export const getCMSEnabledMultiUseCouponList = (state) => {
  return (
    state.session && state.session.siteDetails && state.session.siteDetails.MULTI_USE_COUPON_LIST
  );
};

export const getAccountDrawerOrdersCacheTTL = (state) => {
  return (
    state &&
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.IS_ACCOUNT_DRAWER_ORDERS_CACHE_TTL &&
    parseInt(state.session.siteDetails.IS_ACCOUNT_DRAWER_ORDERS_CACHE_TTL, 10)
  );
};

export const getAccountDrawerWaysToEarnCacheTTL = (state) => {
  return (
    (state &&
      state.session &&
      state.session.siteDetails &&
      state.session.siteDetails.IS_ACCOUNT_DRAWER_WAYS_TO_EARN_CACHE_TTL &&
      parseInt(state.session.siteDetails.IS_ACCOUNT_DRAWER_WAYS_TO_EARN_CACHE_TTL, 10)) ||
    EARNEXTRAPOINTS_CONSTANTS.ACCOUNT_DRAWER_EARNEXTRAPOINTS_LIST_TTL
  );
};

export const getAccountDrawerMyCouponsCacheTTL = (state) => {
  return (
    (state &&
      state.session &&
      state.session.siteDetails &&
      state.session.siteDetails.IS_ACCOUNT_DRAWER_MY_COUPONS_CACHE_TTL &&
      parseInt(state.session.siteDetails.IS_ACCOUNT_DRAWER_MY_COUPONS_CACHE_TTL, 10)) ||
    COUPON_CONSTANTS.ACCOUT_DRAWER_COUPONS_FETCH_CACHE_TTL
  );
};

export const getMakeInventoryCallAsync = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.ASYNC_INVENTORY_CALL)
  );
};

export const getIsAccountDrawerOrdersEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_ACCOUNT_DRAWER_ORDERS_ENABLED)
  );
};

export const getIsGenericSBCRedesignEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_GENERIC_SBC_REDESIGN_ENABLED)
  );
};

export const getIsStoreInventoryApi = (state) => {
  return state &&
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.GET_STORE_INVENTORY_ENABLED
    ? parseBoolean(state.session.siteDetails.GET_STORE_INVENTORY_ENABLED)
    : false;
};

export const getAccountDashboardOrdersCacheTTL = (state) => {
  return (
    (state &&
      state.session &&
      state.session.siteDetails &&
      state.session.siteDetails.IS_ACCOUNT_DASHBOARD_ORDERS_CACHE_TTL &&
      parseInt(state.session.siteDetails.IS_ACCOUNT_DASHBOARD_ORDERS_CACHE_TTL, 10)) ||
    ordersConstants.ACCOUNT_DASHBOARD_ORDERS_LIST_BY_SHIPMENT_TTL
  );
};

export const getIsAccountDashboardOrdersEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_ACCOUNT_DASHBOARD_ORDERS_ENABLED)
  );
};

export const isPlacePerkEnabled = (state) => {
  if (isCanada()) return false;

  return (
    state &&
    state.session.siteDetails &&
    state.session.siteDetails.IS_PLACE_PERK_ENABLED &&
    parseBoolean(state.session.siteDetails.IS_PLACE_PERK_ENABLED)
  );
};

export const getAutoApplyPerkCouponType = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.AUTO_APPLY_PERK_COUPON_TYPE
  );
};

export const getBaseStarPeakValue = (state) => {
  return (
    state &&
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.BASE_STAR_PEAK_VALUE &&
    parseInt(state.session.siteDetails.BASE_STAR_PEAK_VALUE, 10)
  );
};

export const getRockStarPeakValue = (state) => {
  return (
    state &&
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.ROCKSTAR_PEAK_VALUE &&
    parseInt(state.session.siteDetails.ROCKSTAR_PEAK_VALUE, 10)
  );
};

export const getSuperStarPeakValue = (state) => {
  return (
    state &&
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.SUPERSTAR_PEAK_VALUE &&
    parseInt(state.session.siteDetails.SUPERSTAR_PEAK_VALUE, 10)
  );
};
export const getMegaStarPeakValue = (state) => {
  return (
    state &&
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.MEGASTAR_PEAK_VALUE &&
    parseInt(state.session.siteDetails.MEGASTAR_PEAK_VALUE, 10)
  );
};

export const getStatusRewardsValue = (state) => {
  return (
    state &&
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.STATUS_REWARDS_VALUE &&
    parseInt(state.session.siteDetails.STATUS_REWARDS_VALUE, 10)
  );
};

export const getIsKillItemCountCompare = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.KILL_ITEM_COUNT_COMPARE)
  );
};

export const getIsSyteEnabledOnQV = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.SYTE_ON_QV_TURNED_OFF)
  );
};

export const getIsExpressAfterpayEnabled = (state) => {
  const currentLang = getCurrentSiteLanguage(state);
  if (isCanada() || currentLang === 'es' || getIsInternationalShipping(state)) return false;
  const getAbtests = getABtestFromState(state.AbTest);
  const backABDisabled = !(getAbtests && getAbtests.isExpressAfterpayBackABenabled);

  return (
    parseBoolean(
      state[SESSIONCONFIG_REDUCER_KEY] &&
        state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_EXPRESS_AFTERPAY
    ) && backABDisabled
  );
};

export const getBIABagpageConfigData = (state) => {
  if (state && state.session.siteDetails) {
    const {
      bia_bagpage_cacheTTL,
      bia_bagpage_categoryCode,
      bia_bagpage_dateOnlySorting,
      bia_bagpage_noOfProducts,
      bia_bagpage_sortingOrder,
    } = state.session.siteDetails;
    return {
      cacheTTL: bia_bagpage_cacheTTL,
      sortingOrder: bia_bagpage_sortingOrder,
      categoryCode: bia_bagpage_categoryCode,
      dateOnlySorting: bia_bagpage_dateOnlySorting,
      noOfProducts: bia_bagpage_noOfProducts,
    };
  }
  return null;
};

export const getIsBIABagPageCustomVariableEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.IS_BIA_BAGPAGE_ENABLED)
  );
};

export const getPlacePerksDisplayThreshold = createSelector(getSiteDetails, (siteDetails) => {
  return parseInt(siteDetails.PLACE_PERKS_THRESHOLD || 25, 10);
});

export const getBaseStarPerks = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.BASESTAR_PERKS &&
    safelyParseJSON(state.session.siteDetails.BASESTAR_PERKS)
  );
};

export const getRockStarPerks = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.ROCKSTAR_PERKS &&
    safelyParseJSON(state.session.siteDetails.ROCKSTAR_PERKS)
  );
};

export const getSuperStarPerks = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.SUPERSTAR_PERKS &&
    safelyParseJSON(state.session.siteDetails.SUPERSTAR_PERKS)
  );
};

export const getMegaStarPerks = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.MEGASTAR_PERKS &&
    safelyParseJSON(state.session.siteDetails.MEGASTAR_PERKS)
  );
};

export const getPlccMegaStarPerks = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.PLCC_MEGASTAR_PERKS &&
    safelyParseJSON(state.session.siteDetails.PLCC_MEGASTAR_PERKS)
  );
};

export const getRedeemedAndEarnedPerksCacheTTL = (state) => {
  return (
    (state &&
      state.session &&
      state.session.siteDetails &&
      state.session.siteDetails.REDEEMED_AND_EARNED_PERKS_FETCH_CACHE_TTL &&
      parseInt(state.session.siteDetails.REDEEMED_AND_EARNED_PERKS_FETCH_CACHE_TTL, 10)) ||
    redeemedAndEarnedPerksConstants.REDEEMED_AND_EARNED_PERKS_FETCH_CACHE_TTL
  );
};

export const getIsBagPageAnimationEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.IS_BAGPAGE_DELETE_ANIMATION_ENABLED)
  );
};

export const getIsNewPegaDigitalChatEnabled = (state) => {
  return (
    state &&
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.IS_PEGA_DIGITAL_CHAT)
  );
};

export const getIsHideOriginalPriceAndMarchantTagEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.IS_HIDE_ORGINAL_PRICE_AND_MARCHANT_TAG_ENABLED)
  );
};
export const getABTestIsHomePageInYourBagEnabled = (state) => {
  return state?.AbTest && getABtestFromState(state.AbTest).isHomePageInYourBagEnabled;
};

export const getIsHideOutfitsOnApp = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.HIDE_OUTFITS_LINKS_IN_NAV_APP)
  );
};

export const getIsBeaconDetectionEnabled = (state) => {
  return (
    state &&
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.IS_BEACON_DETECTION_ENABLED_APP &&
    parseBoolean(state.session.siteDetails.IS_BEACON_DETECTION_ENABLED_APP)
  );
};

export const getIsHomePageBeaconDetectionEnabled = (state) => {
  return (
    state &&
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.IS_HOME_PAGE_BEACON_DETECTION_ENABLED_APP &&
    parseBoolean(state.session.siteDetails.IS_HOME_PAGE_BEACON_DETECTION_ENABLED_APP)
  );
};

export const getIsAppRatingPromptEnabled = (state) => {
  return (
    state &&
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.IS_RATING_PROMPT_ENABLED_APP &&
    parseBoolean(state.session.siteDetails.IS_RATING_PROMPT_ENABLED_APP)
  );
};

export const getIsBIAOrderDetailsEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.IS_BIA_ORDER_DETAILS_ENABLED &&
    parseBoolean(state.session.siteDetails.IS_BIA_ORDER_DETAILS_ENABLED)
  );
};

export const getTileRedesignAB = (state) => {
  const abTestValue = getABtestFromState(state?.AbTest)?.isTileRedesign;
  let variation = 'variationA';
  if (abTestValue && abTestValue.colorSwatch === 'text') {
    variation = 'variationB';
  }
  if (abTestValue && abTestValue.productTile === 'old') {
    variation = false;
  }
  return variation;
};

export const getABTestSetPLPSLPAddToCartCTA = (state) => {
  let finalAbTest = 'off';

  const isATBIconEnabled = getABtestFromState(state?.AbTest)?.isATBIconEnabled;

  if (isATBIconEnabled) {
    finalAbTest = 'icon';
  }
  return finalAbTest;
};

export const getLoadOnScrollHpModuleEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.IS_LOAD_HP_MODULE_ON_SCROLL &&
    parseBoolean(state.session.siteDetails.IS_LOAD_HP_MODULE_ON_SCROLL)
  );
};

export const getABTestIsBOSSswitchEnabled = (state) => {
  return state?.AbTest && getABtestFromState(state.AbTest).isAbTestBOSSswitchEnabled;
};

export const getIsBOSSswitchEnabled = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.IS_BOSS_SWITCH_ENABLED &&
    parseBoolean(state.session.siteDetails.IS_BOSS_SWITCH_ENABLED)
  );
};

export const getIsNavSizePromoEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_NAV_SIZE_PROMO_ENABLED)
  );
};

export const getIsNavSizePromoEnabledApp = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_NAV_SIZE_PROMO_ENABLED_APP)
  );
};

export const getIsLazyLoadHPModules = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_LAZY_LOAD_HP_MODULES)
  );
};

export const getLazyLoadHPModulesCount = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
    parseInt(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.LAZY_LOAD_HP_MODULES_COUNT, 10)
  );
};

export const getNewChangeStoreUICNC = (state) => {
  return (
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.NEW_CHANGE_STORE_UI_CNC_ENABLE &&
    parseBoolean(state.session.siteDetails.NEW_CHANGE_STORE_UI_CNC_ENABLE)
  );
};

export const getIsInfluencerBadgeEnabledForListingPages = (state) => {
  return state?.AbTest && getABtestFromState(state?.AbTest).isListingPagesInfluencerHandleAbTest;
};
export const getIsBIAEnabledForOrderHistory = (state) => {
  return (
    state &&
    state?.session &&
    state?.session?.siteDetails &&
    parseBoolean(state?.session?.siteDetails?.IS_BIA_ENABLED_FOR_ORDER_HISTORY)
  );
};

export const getIsNewLoginScreen = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_NEW_LOGIN_SCREEN)
  );
};

export const getIsNewEddViewCheckout = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_NEW_EDDVIEW_CHECKOUT)
  );
};

export const getIsShopBySizeEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_SHOP_BY_SIZE_APP)
  );
};

export const getisRatingRedesignAbTest = (state) => {
  return state?.AbTest && getABtestFromState(state.AbTest).isRatingRedesignAbTest;
};

export const getIsPromotionRedesignAbTest = (state) => {
  return state?.AbTest && getABtestFromState(state.AbTest)?.isPromotionRedesignAbTest;
};

export const getIsAppColorSwatchRedesignAbTest = (state) => {
  return state?.AbTest && getABtestFromState(state.AbTest).isColorSwatchAppRedesignAB;
};

export const getIsResetPasswordAutoLoginEnabled = () => {
  return true;
};

export const getcouponSectionNewDesign = () => {
  return true;
};

export const getcouponOnHoldNewDesign = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_COUPON_ON_HOLD_NEW_DESIGN_ENABLED)
  );
};

export const getcouponOnHoldEmptyCartEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_COUPON_ON_HOLD_EMPTY_CART_ENABLED)
  );
};

export const getInitialSFLItemsQty = (state) => {
  return state && state?.session?.siteDetails && state?.session?.siteDetails?.INITIAL_SFL_ITEMS_QTY;
};

export const getIsHplpFiltersEnabled = (state) => {
  return state?.AbTest && getABtestFromState(state?.AbTest).isHplpFiltersEnabled;
};

export const getRecommendationsPlacementAbTest = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return abTests?.isRecommendationsPlacementEnabled;
  }
);

export const getHomePageCustomCarousel = (state) => {
  return parseBoolean(
    state &&
      state[SESSIONCONFIG_REDUCER_KEY] &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
      state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_HOMEPAGE_CUSTOM_CAROUSEL_APP &&
      parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_HOMEPAGE_CUSTOM_CAROUSEL_APP)
  );
};

export const getIsHpInViewPortEnablePlayMode = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_HP_IN_VIEWPORT_ENABLE_PLAY)
  );
};

export const getIsNewPlccEnabledAbtest = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return abTests?.isNewPlccEnabled;
  }
);

export const getIsSingleOptionEnabled = (state) => {
  const getAbtests = getABtestFromState(state.AbTest);
  return !parseBoolean(getAbtests && getAbtests.isSingleOptionEnabled);
};

export const getEnableHomepageRNRNewDesign = (state) => {
  return (
    state &&
    state.session.siteDetails &&
    state.session.siteDetails.IS_HOMEPAGE_RNR_NEW_DESIGN_ENABLED &&
    parseBoolean(state.session.siteDetails.IS_HOMEPAGE_RNR_NEW_DESIGN_ENABLED)
  );
};
export const getWalletCouponRedesign = (state) => {
  return (
    state &&
    state.session.siteDetails &&
    state.session.siteDetails.IS_WALLET_COUPON_REDESIGN_ENABLED &&
    parseBoolean(state.session.siteDetails.IS_WALLET_COUPON_REDESIGN_ENABLED)
  );
};

export const getIsBonusPointDayEnabled = (state) => {
  if (isCanada()) return false;

  return (
    state &&
    state.session.siteDetails &&
    state.session.siteDetails.IS_BONUS_POINT_DAY_ENABLED &&
    parseBoolean(state.session.siteDetails.IS_BONUS_POINT_DAY_ENABLED)
  );
};

export const getIsCouponSmoothScrollEnabled = (state) => {
  return (
    state &&
    state.session.siteDetails &&
    state.session.siteDetails.IS_COUPON_SMOOTH_SCROLL_ENABLED &&
    parseBoolean(state.session.siteDetails.IS_COUPON_SMOOTH_SCROLL_ENABLED)
  );
};

export const getOutfitDetailsPageRedesign = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return !parseBoolean(abTests?.isOutfitDetailsPageRedesign);
  }
);

export const getCombinedKits = (state) => {
  return parseBoolean(state?.session?.siteDetails?.COMBINED_KITS_ENABLED);
};

export const getMPRandCSHCouponRedesign = (state) => {
  return (
    state &&
    state.session.siteDetails &&
    state.session.siteDetails.IS_MPR_CSH_COUPON_REDESIGN_ENABLED &&
    parseBoolean(state.session.siteDetails.IS_MPR_CSH_COUPON_REDESIGN_ENABLED)
  );
};

export const getIsRecommendationCarouselRedesignEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return !abTests?.isRecommendationCarouselRedesignEnabled;
  }
);

export const getIsModuleGV2 = (state) => {
  return (
    state &&
    state.session.siteDetails &&
    state.session.siteDetails.IS_MODULEG_V2 &&
    parseBoolean(state.session.siteDetails.IS_MODULEG_V2)
  );
};
export const getAISearchEnabled = (state) => {
  return (
    state &&
    state.session.siteDetails &&
    state.session.siteDetails.AI_SEARCH_ENABLED &&
    parseBoolean(state.session.siteDetails.AI_SEARCH_ENABLED)
  );
};

export const getOrderHistoryExtended = (state) => {
  return (
    state &&
    state.session.siteDetails &&
    state.session.siteDetails.IS_ORDER_HISTORY_EXTENDED_ENABLED &&
    parseBoolean(state.session.siteDetails.IS_ORDER_HISTORY_EXTENDED_ENABLED)
  );
};

export const getNumberOfYears = (state) => {
  return (
    state &&
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.ORDERS_EXTENDED_PAST_YEARS_COUNT
  );
};

export const getOrderHistoryExtendedPageSize = (state) => {
  return (
    state &&
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.ORDERS_HISTORY_EXTENDED_PAGE_SIZE
  );
};

export const showFeedbackModalOnOrderConfirm = (state) => {
  return (
    state &&
    state.session &&
    state.session.siteDetails &&
    parseBoolean(state.session.siteDetails.SHOW_FEEDBACK_MODAL_ON_ORDER_CONFIRM)
  );
};

export const getSocialProofingMessageApp = () => {
  return null;
};

export const getBonusPointsEventMessaging = (state) => {
  if (isCanada()) return false;
  return state?.AbTest && getABtestFromState(state.AbTest).isBonusPointsEventMessagingEnabled;
};

export const getBonusPointsEventMessageValue = (state) => {
  return (
    state &&
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.BONUS_POINTS_EVENT_MESSAGE_VALUE &&
    parseInt(state.session.siteDetails.BONUS_POINTS_EVENT_MESSAGE_VALUE, 10)
  );
};
export const getOutfitV3Widget = createSelector(getSiteDetails, (siteDetails) => {
  return (
    parseBoolean(siteDetails.IS_OUTFIT_V3_WIDGET_ENABLED) &&
    !parseBoolean(siteDetails.IS_STYLITICS_COMPOSER_WIDGET_ENABLED)
  );
});

export const getIsStyliticsComposerWidgetEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_STYLITICS_COMPOSER_WIDGET_ENABLED);
});

export const getOutfitV3WidgetVDABTest = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return parseBoolean(abTests?.outfitV3WidgetViewDetail);
  }
);

export const getOutfitV3WidgetMnMABTest = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return !parseBoolean(abTests?.outfitV3WidgetMnM);
  }
);

export const getIsHpHLSEnabled = (state) => {
  return (
    state &&
    state[SESSIONCONFIG_REDUCER_KEY] &&
    state[SESSIONCONFIG_REDUCER_KEY].siteDetails &&
    parseBoolean(state[SESSIONCONFIG_REDUCER_KEY].siteDetails.IS_HP_HLS_ENABLED)
  );
};

export const getIsRedesignedPaymentStepKillSwitch = createSelector(
  getSiteDetails,
  (siteDetails) => {
    return parseBoolean(siteDetails?.IS_REDESIGNED_PAYMENT_STEP_ENABLED);
  }
);

export const getIsMakeDefaultUxUpdateKillSwitch = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails?.IS_MAKE_DEFAULT_UX_UPDATE_ENABLED);
});

export const getIsRedesignedPaymentStep = createSelector(
  getIsRedesignedPaymentStepKillSwitch,
  (state) => getABtestFromState(state.AbTest),
  (isRedesignedPaymentStepEnabled, abTests) => {
    return (
      isRedesignedPaymentStepEnabled && !parseBoolean(abTests?.isRedesignedPaymentStepDisabled)
    );
  }
);

export const getPlccEnabledOnPaymentStep = createSelector(
  getIsRedesignedPaymentStepKillSwitch,
  (state) => getABtestFromState(state.AbTest),
  (isRedesignedPaymentStepEnabled, abTests) => {
    return isRedesignedPaymentStepEnabled && !parseBoolean(abTests?.isPlccDisabledOnPaymentStep);
  }
);

export const getCouponCodePlacementAbtest = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return abTests?.isCouponCodePlacementAbtestEnabled;
  }
);

export const getIsAppPaymentRedesignEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails?.IS_MAKE_DEFAULT_UX_UPDATE_ENABLED_APP);
});

export const guestFavItemsLimit = createSelector(
  getSiteDetails,
  (siteDetails) => siteDetails?.GUEST_FAV_ITEMS_LIMIT
);

export const getIsNewDesignToggleOptionsEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return parseBoolean(abTests?.isNewDesignToggleOptionsEnabled);
  }
);

export const getDefaultView = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails?.DEFAULT_OUTFIT_NEW_DESIGN_VIEW;
});

export const getIsPJPlannerExperienceEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return parseBoolean(abTests?.isPJPlannerExperienceEnabled);
  }
);

export const getIsAlsoAvailablePillsDisabled = createSelector(
  getSiteDetails,
  (state) => getABtestFromState(state.AbTest),
  (siteDetails, abTests) => {
    if (parseBoolean(siteDetails.ALSO_AVAILABLE_PILLS_ENABELED)) {
      return parseBoolean(abTests?.alsoAvailablePillsDisabled);
    }
    return true;
  }
);
export const getNewCouponUXWithoutTabKillSwitch = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails?.COUPON_HORIZONTAL_LIST_DESIGN_ENABLED);
});

export const getBossUnavailableKillSwitch = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails?.IS_BOSS_UNAVAILABLE_ENABLED);
});

export const getBossUnavailableSwitch = createSelector(
  getBossUnavailableKillSwitch,
  (state) => getABtestFromState(state.AbTest),
  (isBossUnavailableKillSwitch, abTests) => {
    return isBossUnavailableKillSwitch && !parseBoolean(abTests?.isBossUnavailableDisabled);
  }
);

/**
 * This function checks if the Pixlee application is enabled or not using the The enabling status is determined
 *  by the `IS_PIXLEE_FLAG_ENABLED_APP` property in `state.session.siteDetails`.
 */
export const isPixleeAppEnabled = (state) => {
  return parseBoolean(state?.session?.siteDetails.IS_PIXLEE_FLAG_ENABLED_APP);
};

/**
 * This function checks if the BazaarVoice application is enabled or not using the The enabling status is determined
 *  by the `IS_BV_FLAG_ENABLED_APP` property in `state.session.siteDetails`.
 */
export const isBVAppEnabled = (state) => {
  return parseBoolean(state?.session?.siteDetails.IS_BV_FLAG_ENABLED_APP);
};

export const getIsShareCartEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_SHARE_CART_ENABLED);
});

export const isPixleeWebEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_PIXLEE_FLAG_ENABLED);
});

export const isPixleeCustomWARWebEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_PIXLEE_CUSTOM_WAR_ENABLED);
});

export const isBVWebEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_BV_FLAG_ENABLED);
});

export const getSeoHeaderAlignTopEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_SEO_HEADER_ALIGN_TOP_ENABELD);
});

export const getCouponExpiryTimeDifference = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails.COUPON_EXPIRY_TIME_DIFF;
});

export const getIsModuleJV2 = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_MODULEJ_V2);
});

export const getIsOutfitCarouselModuleV2 = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_OUTFIT_CAROUSEL_MODULE_V2);
});

export const getBrandTabAnchorToButtonEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.BRAND_TAB_ANCHOR_TO_BUTTON_ENABLED);
});

export const getFadeImageHoverEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.FADE_IMAGE_HOVER_ENABLED);
});

export const getConfirmationPageHeaderAndButton = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return !parseBoolean(abTests?.isConfirmationPageHeaderAndButtonDisabled);
  }
);
export const getShowSiteCookiesDisclaimer = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_SHOW_SITE_COOKIES_DISCLAIMER_ENABLED);
});

export const getRedirectModalDisclaimer = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_REDIRECT_MODAL_DISCLAIMER_ENABLED);
});

export const getIsBIACombinedCarouselKillSwitch = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_BIA_BAGPAGE_KILL_SWITCH_ENABLED);
});

export const getIsPinchZoomPDPImageEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_PINCH_ZOOM_IMAGE_ENABLED);
});

export const getTopPromoMessageAppEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_TOP_PROMO_MESSAGE_APP_ENABLED);
});

export const getIsQnAWebEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_QNA_ENABLED);
});

export const getIsQnAAppEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_QNA_ENABLED_APP);
});

export const getIsOOSColorSwatchRemoved = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_OOS_COLOR_SWATCH_REMOVED);
});

export const getIsShowPromoPriceMicroData = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_SHOW_PROMO_PRICE_MICRO_DATA);
});

export const getIsOrderableFilterEnable = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_UNBXD_ORDERABLE_FLAG);
});

export const getIsSnjPjpBrandDisabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_SNJ_PJP_DISABLED);
});

export const getIsPLCCBannerPriceAbTest = (state) => {
  return state?.AbTest && getABtestFromState(state.AbTest).isPLCCBannerPriceOnPDP;
};

export const getIsOutfitsOnBagEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return parseBoolean(abTests?.isOutfitsOnBagEnabled);
  }
);

export const getOutfitCountOnBag = createSelector(getSiteDetails, (siteDetails) => {
  return parseInt(siteDetails.OUTFIT_COUNTS_TO_SHOW_ON_BAG, 10) || 8;
});

export const getIsFreeShippingProgressBarDisabled = createSelector(
  getSiteDetails,
  (siteDetails) => {
    const isInternationalShipping =
      siteDetails?.country !== defaultCountries[0].id &&
      siteDetails?.country !== defaultCountries[1].id;
    return (
      parseBoolean(siteDetails.IS_FREE_SHIPPING_PROGRESS_BAR_DISABLED) || isInternationalShipping
    );
  }
);

export const getOutfitCarouselPillCategories = createSelector(getSiteDetails, (siteDetails) => {
  return (siteDetails && siteDetails.OUTFIT_PILL_VARIATION_CATEGORIES) || '';
});

export const getFreeShippingThershold = createSelector(getSiteDetails, (siteDetails) => {
  return parseInt(siteDetails.FREE_SHIPPING_THERSHOLD, 10) || 0;
});

export const getIsSnjPjpBrandGiftServicesDisabled = createSelector(
  getSiteDetails,
  (siteDetails) => {
    return parseBoolean(siteDetails.IS_SNJ_PJP_GIFTSERVICES_DISABLED);
  }
);

export const getIsDynamicFreeShippingEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.DYNAMIC_FREE_SHIPPING_ENABLED);
});
export const getDynamicShippingCharge = createSelector(getSiteDetails, (siteDetails) => {
  return parseFloat(siteDetails.DYNAMIC_SHIPPING_CHARGE) || 0;
});

export const getDynamicShippingTax = createSelector(getSiteDetails, (siteDetails) => {
  return parseFloat(siteDetails.DYNAMIC_SHIPPING_TAX) || 0;
});

export const getIsFreeShippingMessagingEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.HIDE_FREE_SHIPPING_MESSEAGE);
});

export const getIsSnjPjpCheckboxesDisabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_SNJ_PJP_CHECKBOX_DISABLED);
});

export const getIsSiteWidePromoBannerAbTestEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return abTests?.isSiteWidePromoBannerAbTestEnabled;
  }
);

export const getIsExtendedHolidayReturnsBannerAbTestEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return abTests?.isExtendedHolidayReturnsBannerAbTestEnabled;
  }
);

export const getIsHolidayGetItByMessageBannerAbTestEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return abTests?.isHolidayGetItByMessageBannerAbTestEnabled;
  }
);

export const getDeadlineDateAndTime = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails.DEADLINE_DATE_AND_TIME;
});

export const getIsSiteWidePromoAbTestEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  getIsInternationalShipping,
  (abTests, isInternationalShipping) => {
    return abTests?.isSiteWidePromoAbTestEnabled && !isInternationalShipping;
  }
);

export const getIsSocialProofViaEngineApiEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails?.IS_SOCIAL_PROOF_VIA_ENGINE_API_ENABLED_APP);
});

export const getPromoKeyConfig = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && siteDetails?.PROMO_KEY_CONFIG;
});

export const getIsSiteBusterAbTestEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return parseBoolean(abTests?.isSiteBusterAbTestEnabled);
  }
);

export const getIsTrendingInCategoryRecommendationsEnabled = createSelector(
  getSiteDetails,
  (state) => getABtestFromState(state.AbTest),
  (siteDetails, abTests) => {
    if (!isClient()) {
      const categoryIds = extractDataFromString(
        siteDetails.CATEGORIES_FOR_TRENDING_IN_CATEGORY_CAROUSEL,
        COMMA_DELIMITER
      );
      return categoryIds?.length > 0;
    }
    return parseBoolean(abTests?.isTrendingInCategoryRecommendationsEnabled);
  }
);

export const getIsTrendingInCategoryRecommendationsDisplayBadgeEnabled = createSelector(
  getSiteDetails,
  (siteDetails) => {
    return parseBoolean(siteDetails?.IS_TRENDING_IN_CATEGORY_RECOMMENDATIONS_DISPLAY_BADGE_ENABLED);
  }
);

export const getIsATBEnabledForCancelledOrder = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails?.ATB_FOR_CANCELLED_ORDERS_ENABLED);
});

export const getPlccICForRememberedUserEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails?.PLCC_IC_FOR_REMEMBERED_USER_ENABLED);
});

export const getPlccPostApplicationExperienceEnabled = createSelector(
  getSiteDetails,
  (siteDetails) => {
    return siteDetails && parseBoolean(siteDetails?.PLCC_POST_APPLICATION_EXPERIENCE_ENABLED);
  }
);

export const getIsOptimizeApplePaySheet = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails?.IS_OPTIMIZE_APPLE_PAY_SHEET);
});

export const getDeviceSpecificCouponList = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && safelyParseJSON(siteDetails.DEVICE_SPECIFIC_COUPON_LIST);
});

export const getShowColorSwatchLabelOnApp = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.IS_SHOW_COLOR_SWATCH_LABEL_ON_APP);
});

export const getDesktopProductTileCleanUpDisabled = createSelector(
  getSiteDetails,
  (state) => getABtestFromState(state.AbTest),
  (siteDetails, abTests) => {
    if (!isMobileWeb() && parseBoolean(siteDetails?.IS_DESKTOP_PRODUCT_TILE_CLEANUP_ENABLED)) {
      return !parseBoolean(abTests?.isDesktopProductTileCleanUpEnabled);
    }
    return true;
  }
);
export const getIsNewATBProductInformationDesign = (state) => {
  return state?.AbTest && getABtestFromState(state.AbTest).IsNewATBProductInformationDesignEnabled;
};

export const getRefreshCouponOnSubmitShipping = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.REFRESH_COUPON_ON_SUBMIT_SHIPPING);
});

export const getIsAddCouponHomepageEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.IS_ADD_COUPON_HOMEPAGE_ENABLED);
});

export const getStyliticsV3CarouselTags = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && safelyParseJSON(siteDetails.STYLITICS_V3_CAROUSEL_TAGS);
});

export const getStyliticsCarouselBgColor = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && siteDetails.STYLITICS_CAROUSEL_BG_COLOR;
});

export const getIsFreeShippingLedgerMessageEnabled = createSelector(
  getSiteDetails,
  (siteDetails) => {
    const isInternationalShipping =
      siteDetails?.country !== defaultCountries[0].id &&
      siteDetails?.country !== defaultCountries[1].id;
    return (
      parseBoolean(siteDetails.IS_FREE_SHIPPING_MESSAGE_ON_LEDGER_ENABLED) &&
      parseInt(siteDetails?.FREE_SHIPPING_THERSHOLD, 10) > 0 &&
      !isInternationalShipping
    );
  }
);
export const getSiteMaintainanceBannerData = (state) => {
  return state?.AbTest && getABtestFromState(state.AbTest).siteMaintenanceBanner;
};

export const getSiteMaintainancePopupEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.SITE_MAINTENANCE_POPUP_ENABLED);
});

export const getIsApplyCheckboxPromoOnPDPEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return parseBoolean(abTests?.isApplyCheckboxPromoOnPdp);
  }
);

export const getIsOTpScreenEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.CREATE_ACCOUNT_OTP_VERIFICATION_ENABLED);
});

export const getIsHomepageFullPageWidthEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.IS_HOMEPAGE_FULL_PAGE_WIDTH_ENABLED);
});

export const getIsCheckoutIconsClickableEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.IS_CHECKOUT_ICONS_CLICKABLE_ENABLED);
});

export const getIsSEOCarouselShiftingAllowed = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return parseBoolean(abTests?.isSeoCarouselShiftingAllowed);
  }
);

export const getQuickAddFreeShippingRecsThreshold = createSelector(
  getSiteDetails,
  (siteDetails) => {
    return parseFloat(siteDetails?.QUICK_ADD_FREE_SHIPPING_RECS_THRESHOLD || 0);
  }
);

export const getQuickAddFreeShippingRecsThresholdA = createSelector(
  getSiteDetails,
  (siteDetails) => {
    return parseFloat(siteDetails?.QUICK_ADD_FREE_SHIPPING_RECS_THRESHOLD_A || 0);
  }
);

export const getQuickAddFreeShippingRecsThresholdB = createSelector(
  getSiteDetails,
  (siteDetails) => {
    return parseFloat(siteDetails?.QUICK_ADD_FREE_SHIPPING_RECS_THRESHOLD_B || 0);
  }
);
export const getQuickAddFreeShippingRecsThresholdC = createSelector(
  getSiteDetails,
  (siteDetails) => {
    return parseFloat(siteDetails?.QUICK_ADD_FREE_SHIPPING_RECS_THRESHOLD_C || 0);
  }
);

export const getIsQuickAddFreeShippingRecsEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return parseBoolean(abTests?.isQuickAddFreeShippingRecsEnabled);
  }
);

export const getSetShippingTotalInCache = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.SET_SHIPPING_TOTAL_IN_CACHE);
});

export const getIsBillingInternationalAddress = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.IS_BILLING_INTERNATIONAL_ADDRESS_ENABLED);
});

export const getPlccOfferPercentage = createSelector(getSiteDetails, (siteDetails) => {
  return parseInt(siteDetails.PLCC_OFFER_PERCENTAGE, 10) || 0;
});

export const getHideContinueShoppingCta = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.HIDE_CONTINUE_SHOPPING_CTA_ON_WIC_CHECKOUT);
});

export const freeShippingMessageForPromos = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.FREE_SHIPPING_MESSAGE_FOR_PROMOS_ENABLED);
});

export const getIsESpotPlpBackABTest = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return parseBoolean(abTests?.isCategoryBreakESpotEnabled);
  }
);

export const getIsOneHrFilterEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.IS_ONE_HR_FILTER_WEB_ENABLED);
});

export const getIsESpotPromoL2PlpWithCategoryBreakEnabled = createSelector(
  getSiteDetails,
  (siteDetails) => {
    return (
      siteDetails && parseBoolean(siteDetails.IS_ESPOT_PROMO_L2_PLP_WITH_CATEGORY_BREAK_ENABLED)
    );
  }
);

export const getIsESpotPromoL1PlpEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.IS_ESPOT_PROMO_L1_PLP_ENABLED);
});

export const getIsESpotPromoL2PlpEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.IS_ESPOT_PROMO_L2_PLP_ENABLED);
});

export const getIsESpotPromoL3PlpEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.IS_ESPOT_PROMO_L3_PLP_ENABLED);
});

export const getIsESpotPromoHplpEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.IS_ESPOT_PROMO_HPLP_ENABLED);
});

export const getIsBIAEnhancementEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.BIA_ENHANCEMENT_ENABLED);
});

export const getIsUpdatedPromotionsDisplayEnabled = createSelector(
  getSiteDetails,
  (siteDetails) => {
    return siteDetails && parseBoolean(siteDetails.IS_UPDATED_PROMOTIONS_DISPLAY_ENABLED);
  }
);

export const getIsOptimizedApplyCouponEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.IS_OPTIMIZED_APPLY_COUPON_ENABLED);
});

export const getIsBopisFilterEnabledOnApp = createSelector(
  getSiteDetails,
  (siteDetails) => siteDetails && parseBoolean(siteDetails.IS_BOPIS_FILTER_ENABLED_ON_APP)
);

export const getIsBopisPromotionDiscountEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.IS_BOPIS_PROMOTION_DISCOUNT_ENABLED);
});

export const getIsTabbedCarouselColorSwatchesEnabled = createSelector(
  getSiteDetails,
  (siteDetails) => {
    return siteDetails && parseBoolean(siteDetails.IS_TABBED_CAROUSEL_COLOR_SWATCHES_ENABLED);
  }
);

export const getIsTabbedCarouselRatingDisabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.IS_TABBED_CAROUSEL_RATIING_DISABLED);
});

export const getIsTabbedCarouselATBDisabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.HIDE_TABBED_CAROUSEL_PRODUCT_ATB);
});

export const getIsTabbedCarouselDiscountPriceDisabled = createSelector(
  getSiteDetails,
  (siteDetails) => {
    return siteDetails && parseBoolean(siteDetails.HIDE_TABBED_CAROUSEL_PRODUCT_DISCOUNT_PRICE);
  }
);

export const getIsTabbedCarouselProductTileBorderDisabled = createSelector(
  getSiteDetails,
  (siteDetails) => {
    return siteDetails && parseBoolean(siteDetails.HIDE_TABBED_CAROUSEL_PRODUCT_TILE_BORDER);
  }
);

export const getIsL3AtL2InHPLPEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.L3_AT_L2_IN_HPLP_ENABLED);
});

export const getIsNewPromotionsAPIEnabled = createSelector(getSiteDetails, (siteDetails) => {
  const { isNewPromotionsAPIEnabled } = getAPIConfig() || {};
  return (
    (siteDetails && parseBoolean(siteDetails.IS_NEW_PROMOTIONS_API_ENABLED)) ||
    isNewPromotionsAPIEnabled
  );
});

export const getOrderSubtotalEnhancementEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return !parseBoolean(abTests?.orderSubtotalEnhancementEnabled);
  }
);

export const getIsEnableShipmentTilesForInternationalSite = createSelector(
  getSiteDetails,
  (siteDetails) => {
    return siteDetails && parseBoolean(siteDetails.SHOW_SHIPMENT_TILES_FOR_INTERNATIONAL_SITES);
  }
);

export const getOrderTrackingEnhancementEnabled = createSelector(getSiteDetails, (siteDetails) => {
  if (isCanada()) return false;
  return siteDetails && parseBoolean(siteDetails.ORDER_TRACKING_ENHANCEMENT);
});

export const getCatForProdGridHide = createSelector(getSiteDetails, (siteDetails) => {
  return (siteDetails && siteDetails.category_hide_grid_app) || '';
});

export const getAddPickUpPersonEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.ORDER_ADD_ALTERNATE_PICKUPPERSON_ENABLED);
});

export const getAltPersonLimit = createSelector(getSiteDetails, (siteDetails) => {
  return (siteDetails && parseInt(siteDetails.ORDER_ADD_ALTERNATE_PICKUPPERSON_LIMIT, 10)) || 0;
});

export const getAltPersonInvalidOrderStatus = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && siteDetails.ORDER_ADD_ALTERNATE_PICKUPPERSON_INVALID_ORDER_STATUS;
});

export const getABTestForRcommAboveProdDesc = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return parseBoolean(abTests?.recommendationAboveProdDesc);
  }
);

export const getIsDynamicSizeChartEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.IS_DYNAMIC_SIZE_CHART_ENABLED);
});

export const getIsAccountBillingInternationalAddress = createSelector(
  getSiteDetails,
  (siteDetails) => {
    return (
      siteDetails && parseBoolean(siteDetails.IS_ACCOUNT_BILLING_INTERNATIONAL_ADDRESS_ENABLED)
    );
  }
);

export const getPLPImageSizeConfig = createSelector(getSiteDetails, (siteDetails) => {
  return (siteDetails && siteDetails.PLP_IMAGE_SIZE_CONFIG) || '';
});

export const getIsPrevPurchasedBadgeEnable = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return parseBoolean(abTests?.isPreviouslyPurchasedBadgeEnable);
  }
);

export const getIsInternationalPhoneNumber = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.IS_INTERNATIONAL_PHONE_NUMBER_ENABLED);
});

export const getIsDisablePaysecureReset = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_PAYSECURE_RESET_DISABLED);
});

export const getIsUserRefreshOnSubscriptionEnabled = createSelector(
  getSiteDetails,
  (siteDetails) => {
    return siteDetails && parseBoolean(siteDetails.USER_REFRESH_ON_SUBSCRIPTION);
  }
);

export const getIsHeaderScrollViewDisabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_HEADER_SCROLL_VIEW_DISABLED);
});

export const getIsDrawerTransitionEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_DRAWER_TRANSITION_ENABLED);
});

export const getIsShippingChargesApplicableForAfterPayEnabled = createSelector(
  getSiteDetails,
  (siteDetails) => {
    return parseBoolean(siteDetails.IS_SHIPPING_CHARGES_APPLICABLE_FOR_AFTERPAY_ENABLED);
  }
);

export const getIsStickyHeaderBgColorEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_STICKY_HEADER_BG_COLOR_ENABLED);
});

export const getIsSuppressApplePayEmailFieldEnabled = createSelector(
  getSiteDetails,
  (siteDetails) => {
    return siteDetails && parseBoolean(siteDetails.IS_SUPPRESS_APPLEPAY_EMAIL_FIELD_ENABLED);
  }
);

export const getGiftServiceOnBagSection = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_GIFT_SERVICE_ON_BAG_SECTION);
});

export const getGiftServiceVisible = createSelector(
  getGiftServiceOnBagSection,
  getSiteDetails,
  (isGcEnabledOnBagSection, siteDetails) => {
    if (isGcEnabledOnBagSection) return false;
    return parseBoolean(siteDetails.IS_GIFT_SERVICE_ENABLED);
  }
);

export const getIsOrderTrackingPushNotificationSignupEnabled = createSelector(
  getSiteDetails,
  (siteDetails) => {
    return parseBoolean(siteDetails?.IS_ORDER_TRACKING_PUSH_NOTIFICATION_SIGNUP_ENABLED_APP);
  }
);

export const getIsShowDeleteIconInBag = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_SHOW_DELETE_ICON_IN_BAG);
});

export const getIsOutfitCarouselPillEnabled = (state) => {
  return state?.AbTest && getABtestFromState(state.AbTest).outfitCarouselPill;
};

export const getOutfitCarouselPillCategoriesAB = createSelector(getSiteDetails, (siteDetails) => {
  return (siteDetails && siteDetails.OUTFIT_PILL_VARIATION_CATEGORIES_AB) || '';
});

export const getIsSupressATBModalOnBag = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.SUPRESS_ADDED_TO_BAG_MODAL_ON_BAG);
});

export const getIsBackToQuickviewCTAEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_BACK_TO_QV_CTA_ENABLED);
});

export const getMobileWebProductTileEnhancement = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    if (isMobileWeb()) {
      return abTests?.isMobileWebProductTileEnhancement;
    }
    return false;
  }
);

export const getDisplaySitewideCouponByBrand = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.DISPLAY_SITWIDE_PROMO_BY_BRAND_ENABLED);
});

export const getDateFixForMultiuseCoupons = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_DATE_FIX_FOR_MULTIUSE_COUPONS_ENABLED);
});

export const getShowBopisTileBasedOnStoreSpecials = createSelector(
  getSiteDetails,
  (siteDetails) => {
    return parseBoolean(siteDetails.SHOW_BOPIS_TILE_BASED_ON_STORE_SPECIALS);
  }
);

export const getShowStoreSpecialsV2 = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.STORE_SPECIALS_PHASE_2_ENABLED);
});

export const getStoreSpecialsPREnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.STORE_SPECIALS_PRICE_RANGE_ENABLED);
});

export const getIsAddressVerificationBadgeEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return abTests?.isAddressVerificationBadgeEnabled;
  }
);

export const getStoreSpecialDiscountDefaultValue = createSelector(getSiteDetails, (siteDetails) => {
  return parseInt(siteDetails.DEFAULT_STORE_SPECIAL_DISCOUNT_VALUE, 10);
});

export const getLoginFlowUXEnhancement = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.LOGIN_FLOW_UX_ENHANCEMENT);
});

export const getSBCDesignVariationRectangle = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.SBC_DESIGN_VARIATION_RECTANGLE);
});

export const getSBCDesignVariationCircle = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return abTests?.SBC_DESIGN_VARIATION_CIRCLE;
  }
);

export const getOrderDetailsRecommendations = createSelector(
  getSiteDetails,
  (state) => getABtestFromState(state.AbTest),
  (siteDetails, abTests) => {
    return (
      parseBoolean(siteDetails.ORDER_DETAILS_RECOMMENDATIONS) &&
      !abTests?.orderDetailsProductRecommendations
    );
  }
);

export const getSuppressCvvField = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return abTests?.suppressCvvField;
  }
);

export const getIsRedesignGlobalHeaderEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_HEADER_REDESIGNED_ENABLED);
});

export const getIsUpdatedCanadaTermsAndConditions = createSelector(
  getSiteDetails,
  (siteDetails) => {
    if (isCanada()) {
      return parseBoolean(siteDetails.IS_UPDATE_CANADA_TERMS_AND_CONDITIONS_ENABLED);
    }
    return false;
  }
);

export const getSMSUpdatesAPIOptimization = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.SMS_UPDATES_API_OPTIMIZATION_ENABLED);
});

export const getSMSUpdatesSingleOptInEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.SMS_UPDATES_SINGLE_OPT_IN_ENABLED);
});

export const showStoreSpecialProductsOnStoreDetails = createSelector(
  getSiteDetails,
  (siteDetails) => {
    return parseBoolean(siteDetails.SHOW_STORE_SPECIAL_PRODUCTS_ON_STORE_DETAIL);
  }
);

export const getIsMobileNavigationRedesignEnabled = createSelector(
  getSiteDetails,
  (siteDetails) => {
    return parseBoolean(siteDetails.IS_MOBILE_NAVIGATION_REDESIGN_ENABLED);
  }
);

export const isUpdateCallOnApplepayInitEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.UPDATE_CALL_ON_APPLEPAY_INIT);
});

export const getIsEditInCheckoutMyBagEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return parseBoolean(abTests?.isEditInCheckoutMyBagEnabled);
  }
);

export const getIsPJPlannerStickyMiniBagEnabled = createSelector(getSiteDetails, (siteDetails) => {
  if (isMobileWeb()) {
    return false;
  }
  return parseBoolean(siteDetails.IS_PJ_PLANNER_STICKY_MINIBAG_ENABLED);
});

export const getSfccSocialProofingEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.SFCC_SOCIAL_PROOFING_ENABLED);
});

export const getSfccSocialProofingThreshold = createSelector(getSiteDetails, (siteDetails) => {
  return parseInt(siteDetails.SFCC_SOCIAL_PROOFING_THRESHOLD, 10);
});

export const showLSPMEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.SHOW_LSPM_ENABLED);
});

export const getDefaultStoreMessage = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails.DEFAULT_LSPM_CONTENT && safelyParseJSON(siteDetails.DEFAULT_LSPM_CONTENT);
});

export const getNewSEOHreflangLinkEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_NEW_SEO_HREFLANG_LINKS_ENABLED);
});

export const getIsSearchBarAlignmentEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_SEARCH_BAR_ALIGNMENT_ENABLED);
});

export const getIsHideLoginLoader = createSelector(getSiteDetails, (siteDetails) => {
  // TODO: Remove the killswitch with 12.1 release
  return parseBoolean(siteDetails.IS_HIDE_LOGIN_LOADER_IMMEDIATELY);
});

export const getNewGlobalErrorMessage = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.NEW_GLOBAL_ERROR_MESSAGE);
});

export const getIsStageHoldCategoriesOosEnabled = () => {
  return parseBoolean(getAPIConfig()?.stageHoldCategoryOosEnabled) || false;
};

export const getNewGlobalErrorMessageDuration = createSelector(getSiteDetails, (siteDetails) => {
  return parseInt(siteDetails.NEW_GLOBAL_ERROR_MESSAGE_DURATION, 10) || 4000;
});

export const getIsAppendUPCInPDPURLEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_APPEND_UPC_IN_PDP_URL_ENABLED);
});

export const allowOnlineProductPickup = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails?.ALLOW_ONLINE_PRODUCT_PICKUP);
});

export const getIsAllowOnlineProductPickupEnabled = () => {
  const state = getStoreRef()?.getState();
  return state && allowOnlineProductPickup(state);
};

export const getIsPriceDropNotificationEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  getIsInternationalShipping,
  (abTests, isInternationalShipping) => {
    // Check if the price drop notification is enabled and international shipping is not active
    return parseBoolean(abTests?.isPriceDropNotificationEnabled) && !isInternationalShipping;
  }
);

export const getIsPriceDropNotificationApiEnabled = createSelector(
  getSiteDetails,
  (siteDetails) => {
    return parseBoolean(siteDetails?.IS_PRICE_DROP_NOTIFICATION_API_ENABLED);
  }
);

export const priceDropHolidayList = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails?.PRICE_DROP_HOLIDAYS;
});

export const priceDropPercentage = createSelector(getSiteDetails, (siteDetails) => {
  return parseInt(siteDetails.PRICE_DROP_DISPLAY_PERCENT, 10) || 5;
});

export const getIsPillVariationEnabledOnAllPlps = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails?.IS_OUTFIT_PILL_VARIATION_ON_PLPS_ENABLED);
});

/**
 * Selector to determine if the PLP (Product Listing Page) grid and filters should be hidden.
 *
 * This selector uses the 'createSelector' function to efficiently compute the derived state.
 * It takes 'getSiteDetails' as an input selector and a transformation function that extracts
 * and parses the 'IS_HIDE_PLP_GRID_AND_FILTERS_ENABLED' property from the site details.
 */
export const getIsHidePlpGridAndFiltersEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails?.IS_HIDE_PLP_GRID_AND_FILTERS_ENABLED);
});

export const getIsApplyMultipleCoupons = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails?.APPLY_MULTIPLE_COUPONS);
});

/**
 * Selector to determine if the full-width grid promo feature is enabled.
 *
 * This selector uses the `createSelector` function from the `reselect` library
 * to efficiently compute derived data from the Redux store. It accesses the
 * `siteDetails` state and checks if the `IS_FULLWIDTH_IN_GRID_PROMO_HIDDEN`
 * feature flag is set to true.
 */
export const getIsFullWidthInGridPromoHidden = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails?.IS_FULLWIDTH_IN_GRID_PROMO_HIDDEN);
});

export const getIsSmsSubscriptionModalEnabled = createSelector(getSiteDetails, (siteDetails) => {
  if (isCanada()) return false;
  return parseBoolean(siteDetails?.IS_CONFIRMATION_PAGE_SMS_SUBSCRIPTION_POPUP_MODAL_ENABLED);
});

export const getIsFreeShippingOnFulfillmentTileEnabled = createSelector(
  getSiteDetails, // Input selector to retrieve site details from the state
  (siteDetails) => {
    // Extracts and parses the feature flag from site details
    return parseBoolean(siteDetails?.SHOW_FREE_SHIPPING_ON_FULFILLMENT_TILE);
  }
);

export const getIsSocialProofOnATBButtonEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (AbTest) => {
    return AbTest?.isSocialProofOnAtbButtonEnabled;
  }
);

export const getShowAppDownload = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails?.SHOW_APP_DOWNLOAD);
});

export const getIsSLPNewTileImplementationEnabled = createSelector(
  getSiteDetails,
  (siteDetails) => {
    return parseBoolean(siteDetails?.IS_SLP_NEW_TILE_IMPLEMENTATION_ENABLED);
  }
);

export const getIsDynamicColorSwatchesEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails?.IS_DYNAMIC_COLOR_SWATCHES_ENABLED);
});

export const getIsHoverToPreviewColorSwatchesEnabled = createSelector(
  getSiteDetails,
  (siteDetails) => {
    return parseBoolean(siteDetails?.IS_HOVER_TO_PREVIEW_COLOR_SWATCHES_ENABLED);
  }
);

export const getIsStickyAtbButtonOnQvEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (AbTest) => {
    return AbTest?.isStickyAtbButtonOnQvEnabled;
  }
);

export const getIsGlobalDefaultHeaderRedesignEnabled = () => {
  return parseBoolean(getAPIConfig()?.isGlobalHeaderRedesignEnabled) || false;
};

export const getIsDyEnabled = () => {
  return parseBoolean(getAPIConfig()?.isDyEnabled);
};

export const getIsDyAbTestEnabled = () => {
  return parseBoolean(getAPIConfig()?.isDyAbTestEnabled);
};

export const getIsItemLevelOnHoldMsgEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  getSiteDetails,
  (abTests, siteDetails) => {
    return (
      !abTests?.isItemLevelOnHoldMsgEnabled &&
      parseBoolean(siteDetails?.IS_ITEM_LEVEL_ON_HOLD_MSG_ENABLED)
    );
  }
);

export const getRestrictedShippingStatesEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails?.IS_RESTRICTED_SHIPPING_STATES_ENABLED);
});

export const getStateNameMap = createSelector(getSiteDetails, (siteDetails) => {
  return safelyParseJSON(siteDetails?.STATE_FULLNAME_MAPPING);
});

export const getAdyenSessionCacheTTL = (state) => {
  return (
    state &&
    state.session &&
    state.session.siteDetails &&
    state.session.siteDetails.ADYEN_SESSION_CACHE_TTL &&
    parseInt(state.session.siteDetails.ADYEN_SESSION_CACHE_TTL, 10)
  );
};

export const getIsAdyenCheckoutEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails?.IS_ADYEN_CHECKOUT_ENABLED);
});

export const getIsAdyenApplePayCheckoutEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails?.IS_ADYEN_APPLEPAY_CHECKOUT_ENABLED);
});

export const getIsAdyenApplePayBagPageEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails?.IS_ADYEN_APPLEPAY_BAGPAGE_ENABLED);
});

export const getIsAdyenPaymentEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails?.IS_ADYEN_PAYPAL_PAYMENT_ENABLED);
});

export const getIsPayPalDisabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails?.IS_PAYPAL_DISABLED);
});

export const getAdyenIntentValue = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails?.ADYEN_INTENT || 'authorize';
});

export const getIsPayPalDisabledForPickupOrders = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails?.IS_PAYPAL_PICKUP_DISABLED);
});

export const getIsShippedAndReturnsTabEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (AbTest) => {
    return AbTest?.IsShippedAndReturnsTabEnabled;
  }
);

export const getIsPLCCApplyNowBtnAndLearnMoreBtnEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (AbTest) => {
    return parseBoolean(AbTest?.isPLCCApplyNowBtnAndLearnMoreBtnEnabled);
  }
);

export const getIsPLCCApplyNowBtnAndLearnMoreLinkEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (AbTest) => {
    return parseBoolean(AbTest?.isPLCCApplyNowBtnAndLearnMoreLinkEnabled);
  }
);

export const getIsPLCCApplyNowWithSaveBtnAndLearnMoreLinkEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (AbTest) => {
    return parseBoolean(AbTest?.isPLCCApplyNowWithSaveBtnAndLearnMoreLinkEnabled);
  }
);

export const getIsCashAppAfterpayLogoEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails?.AFTER_PAY_REBRANDING);
});

export const getIsTopH1TagOnPLPEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails?.IS_H1_TAG_ON_TOP);
});

export const getIsSplittingExtendedSizesEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_SPLITTING_EXTENDED_SIZES_ENABLED);
});

export const getIsInteractiveColorSwatchBandEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return parseBoolean(abTests?.isInteractiveColorSwatchBandEnabled);
  }
);

export const getIsHoverToRevealATBButtonEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return parseBoolean(abTests?.isHoverToRevealATBButtonEnabled);
  }
);

export const getIsBgdImageOverrideEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return !parseBoolean(abTests?.isBgdImageOverrideEnabled);
  }
);

export const getIsHideLeftNavigationOnPLPEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return parseBoolean(abTests?.isHideLeftNavigationOnPLPEnabled);
  }
);

export const getIsSimilarProductsEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return parseBoolean(abTests?.isAISimilarStyleEnabled);
  }
);

export const getIsOOSSimilarStyleKillSwitch = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails?.IS_OOS_SIMILAR_STYLE_ENABLED);
});

export const getIsSortAndOneHrFilterRedesignEnabled = createSelector(
  getSiteDetails,
  (siteDetails) => {
    return parseBoolean(siteDetails.IS_SORT_AND_ONE_HR_FILTER_REDESIGN_ENABLED);
  }
);

export const getIsClickableBrandBadgesEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_CLICKABLE_BRAND_BADGES_ENABLED);
});

export const getIsFourTileGridEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_FOUR_TILE_GRID_ENABLED);
});

export const getTsSwatchColorUrlEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_SWATCH_COLOR_URL_ENABLED);
});

export const getIsShippingMethodOnShippingEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  getSiteDetails,
  (abtests, siteDetails) => {
    return (
      !abtests?.isShippingMethodsOnShippingDisabled &&
      parseBoolean(siteDetails.IS_SHIPPING_METHOD_ON_SHIPPING_ENABLED)
    );
  }
);

export const getConfettiAnimationParams = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && safelyParseJSON(siteDetails.CONFETTI_PARAMS);
});

export const getIsViewMapEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_VIEW_MAP_ENABLED);
});

export const getIsQuickFiltersModuleEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_QUICK_FILTERS_MODULE_ENABLED);
});

export const getIsQuickFiltersEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails.IS_QUICK_FILTERS_ENABLED);
});

export const getCharacterImageAnimationParams = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && safelyParseJSON(siteDetails.CHARACTER_IMAGE_ANIMATION_PARAMS);
});

export const getIsBrandExclusionMessageEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails?.IS_BRAND_EXCLUSION_MESSAGE_ENABLED);
});

export const getIsLoyaltyTieringEnabled = createSelector(getSiteDetails, (siteDetails) => {
  const apiConfigObj = getAPIConfig();
  const { isLoyaltySalesForceEnabled = false, isLoyaltySalesForceEnabledCanada = false } =
    apiConfigObj;
  let envSwitch = parseBoolean(isLoyaltySalesForceEnabled);
  if (isCanada()) {
    envSwitch = parseBoolean(isLoyaltySalesForceEnabledCanada);
  }
  return envSwitch || parseBoolean(siteDetails.LOYALTY_SALESFORCE_ENABLED);
});
export const getIsLoyaltyBrandThemeEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails?.LOYALTY_BRAND_THEME_ENABLED);
});
export const getIsManualRedemptionEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails?.LOYALTY_MANUAL_REDEMPTION_ENABLED);
});

export const getIsBriteVerifyForLoginEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails?.IS_BRITE_VERIFY_ENABLED);
});

export const getIsCSHEnabled = createSelector(getSiteDetails, (siteDetails) => {
  const { language = 'en' } = getAPIConfig() || {};

  const langInUpper = language && language.toUpperCase();
  if (langInUpper === 'EN') {
    return parseBoolean(siteDetails?.CSH_ENABLED);
  }
  return parseBoolean(siteDetails[`CSH_ENABLED_${langInUpper}`]);
});

export const getIsPLPDynamicGridHeroEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails?.IS_PLP_DYNAMIC_GRID_HERO_ENABLED);
});

export const getTierUpgradeValues = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && safelyParseJSON(siteDetails?.TIER_UPGRADE_VALUES);
});

export const getIsStyleColorRnREnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails?.IS_STYLE_COLOR_RNR_ENABLED);
});

export const getIsCvvEnabledForAccount = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails?.IS_CVV_ENABLED_FOR_ACCOUNT);
});

export const getIsEbboEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.IS_EBBO_ENABLED);
});

export const getPointsTableInitialDisplayCount = createSelector(getSiteDetails, (siteDetails) => {
  return getSiteDetails && parseInt(siteDetails?.POINTS_TABLE_INITIAL_DISPLAY_COUNT, 10);
});

export const getQuickFiltersCount = createSelector(getSiteDetails, (siteDetails) => {
  return (siteDetails && parseInt(siteDetails?.QUICK_FILTERS_COUNT, 10)) || 3;
});

export const getIsRemoveCategoryBreakEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return parseBoolean(abTests?.isRemoveCategoryBreakEnabled);
  }
);

export const getIsFinalSaleBackABEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return !parseBoolean(abTests?.isFinalSaleDisabled);
  }
);

export const getIsTrueFitEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return parseBoolean(abTests?.isTrueFitEnabled);
  }
);

export const getAdyenApplePayBagPageVisibility = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && siteDetails.APPLE_PAY_BAG_VISIBILITY;
});

export const getAdyenFiveCentsFlagEnabed = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.IS_ADYEN_FIVE_CENTS_FLAG_ENABLED);
});

export const getAdyenApplePayMultiStoreEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.IS_ADYEN_APPLE_PAY_MULTI_STORE_DISABLED);
});

export const getAdyenApplePayCheckoutVisibility = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && siteDetails.APPLE_PAY_CHECKOUT_VISIBILITY;
});

export const getEbboAllowedPayments = createSelector(getSiteDetails, (siteDetails) => {
  return safelyParseArray(siteDetails.EBBO_ALLOWED_ALT_PAYMENTS);
});

export const getIsBrandPartnerHoverEffectEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails?.SHOW_BRAND_PARTNER_HOVER_EFFECT_WEB);
});

export const getIsFinalSaleEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.FINAL_SALE_ENABLED);
});

export const getBenefitExpirationDays = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseInt(siteDetails?.BENEFIT_EXPIRATION_DAYS, 10);
});

export const getIsRandomBgColorEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.IS_RANDOM_BG_COLOR_ENABLED);
});

export const getBackgroundColorConfig = createSelector(getSiteDetails, (siteDetails) => {
  return safelyParseArray(siteDetails.BACKGROUND_COLOR_CONFIG);
});

export const getIsLicensedProductTotal = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.IS_LICENSED_PRODUCT_TOTAL_ENABLED);
});

export const getPayPalSingleStoreBopisEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.PAYPAL_SINGLE_STORE_BOPIS_ENABLED);
});

export const getIsPageVisibilityTitleEnabled = createSelector(
  (state) => getABtestFromState(state.AbTest),
  (abTests) => {
    return abTests && parseBoolean(abTests.isPageVisibilityTitleEnabled);
  }
);

export const getPageVisibilityConfig = createSelector(getSiteDetails, (siteDetails) => {
  let config = safelyParseArray(siteDetails.PAGE_VISIBILITY_CONFIG);
  if (Array.isArray(config) && !config.length)
    config = ['Bag', 'ProductDetail', 'SinglePageCheckout']; // Fallback scenario
  return config;
});

export const getDailyPointRedeemLimit = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseInt(siteDetails?.DAILY_POINT_REDEEM_LIMIT || 1000, 10);
});

export const getGuestUserBenefits = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && safelyParseJSON(siteDetails.GUEST_USER_BENEFITS);
});

export const getLoyaltyEarlyAccessWidgetEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails?.EARLY_ACCESS_WIDGET_ENABLED);
});

export const getInactiveTitleFlashing = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.IS_INACTIVE_TITLE_FLASHING_ENABLED);
});

export const getFlashingTimeInMs = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseInt(siteDetails.FLASHING_TIME_IN_MS || 2000, 10);
});

export const getLoyaltyTierValues = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && safelyParseJSON(siteDetails?.LOYALTY_TIERS);
});

export const getAiRecommendationsEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.IS_AI_RECOMMENDATIONS_ENABLED);
});

export const getAddToDefaultFavoritesEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && parseBoolean(siteDetails.ADD_TO_DEFAULT_FAVORITES);
});
export const getCartDetailsCompleteCallforWindows = createSelector(
  getSiteDetails,
  (siteDetails) => {
    return siteDetails && parseBoolean(siteDetails.IS_CART_DETAILS_CALL_WINDOWS_ENABLED);
  }
);

export const getIsSupressPaypalCrossCountryShipping = createSelector(
  getSiteDetails,
  (siteDetails) => {
    return parseBoolean(siteDetails && siteDetails.SUPRESS_PAYPAL_CROSS_COUNTRY_SHIPPING);
  }
);

export const getIsClearanceBrandEnabled = createSelector(getSiteDetails, (siteDetails) => {
  return parseBoolean(siteDetails && siteDetails.IS_CLEARANCE_BRAND_ENABLED);
});

export const getIsAdyenOptimizedApplePayLoadingEnabled = createSelector(
  getSiteDetails,
  (siteDetails) => {
    return parseBoolean(siteDetails && siteDetails.IS_ADYEN_OPTIMIZED_APPLE_PAY_LOADING_ENABLED);
  }
);
export const getBossDefaultRefreshTime = createSelector(getSiteDetails, (siteDetails) => {
  return siteDetails && siteDetails.BOSS_DEFAULT_REFRESH_TIME;
});
